import { exerciseVideos } from './exerciseVideos';

export const exerciseInstructions = {
    // ===== LEG BAND EXERCISES =====
    "G87DeadLift": {
        title: "G87 Resistance Band Deadlift",
        description: "A deadlift movement using resistance bands to target the posterior chain muscles.",
        steps: [
            "Stand on the resistance band with feet hip-width apart.",
            "Hold the handles with an overhand grip, arms extended.",
            "Keep your back straight and chest up.",
            "Hinge at the hips and lower the handles toward the floor.",
            "Drive through your heels to return to the starting position."
        ],
        tips: [
            "Keep the band under tension throughout the movement.",
            "Focus on pushing your hips back rather than bending your knees.",
            "Maintain a neutral spine throughout the exercise.",
            "Squeeze your glutes at the top of the movement."
        ],
        muscleGroups: ["Hamstrings", "Glutes", "Lower Back", "Traps"],
        videoUrl: exerciseVideos["G87DeadLift"],
        image: null
    },

    "G87WideGripBandSquat": {
        title: "G87 Wide Grip Band Squat",
        description: "A squat variation using resistance bands with a wide grip for added upper body engagement.",
        steps: [
            "Stand on the resistance band with feet shoulder-width apart.",
            "Hold the handles with a wide grip above your shoulders.",
            "Keep your chest up and core engaged.",
            "Lower into a squat position by bending at the hips and knees.",
            "Push through your heels to return to the starting position."
        ],
        tips: [
            "Keep your knees tracking over your toes.",
            "Maintain tension in the band throughout the movement.",
            "Don't let your knees cave inward.",
            "Keep your weight on your heels."
        ],
        muscleGroups: ["Quadriceps", "Glutes", "Shoulders", "Core"],
        videoUrl: exerciseVideos["G87WideGripBandSquat"],
        image: null
    },

    "G87WideGripDeadLift": {
        title: "G87 Wide Grip Band Deadlift",
        description: "A deadlift with a wider grip to emphasize different muscle activation patterns.",
        steps: [
            "Stand on the resistance band with feet hip-width apart.",
            "Hold the handles with a wide overhand grip.",
            "Keep your back straight and shoulders back.",
            "Hinge at the hips and lower the handles.",
            "Drive through your heels to return to standing."
        ],
        tips: [
            "The wider grip engages more upper back muscles.",
            "Keep your lats engaged throughout the movement.",
            "Focus on hip hinge movement pattern.",
            "Don't round your back."
        ],
        muscleGroups: ["Hamstrings", "Glutes", "Lower Back", "Lats", "Traps"],
        videoUrl: exerciseVideos["G87WideGripDeadLift"],
        image: null
    },

    // ===== CHEST BAND EXERCISES =====
    "TriangleFloorBenchPress": {
        title: "Triangle Floor Bench Press",
        description: "A floor-based chest press using triangle resistance bands.",
        steps: [
            "Lie on the floor with the band anchored behind you.",
            "Hold the triangle handles at chest level.",
            "Press the handles up and forward, extending your arms.",
            "Slowly lower back to the starting position.",
            "Repeat for desired repetitions."
        ],
        tips: [
            "Keep your core engaged throughout the movement.",
            "Don't let your lower back arch excessively.",
            "Control the negative portion of the movement.",
            "Focus on squeezing your chest at the top."
        ],
        muscleGroups: ["Chest", "Shoulders", "Triceps"],
        videoUrl: exerciseVideos["TriangleFloorBenchPress"],
        image: null
    },

    "G87DoorSmash": {
        title: "G87 Door Smash",
        description: "A dynamic chest exercise using a door anchor and resistance band.",
        steps: [
            "Anchor the band to a door at chest height.",
            "Face away from the door holding the handles.",
            "Step forward to create tension in the band.",
            "Bring your hands together in front of your chest.",
            "Slowly return to the starting position."
        ],
        tips: [
            "Keep your feet staggered for better stability.",
            "Maintain a slight forward lean.",
            "Control the movement on the way back.",
            "Focus on squeezing your chest muscles."
        ],
        muscleGroups: ["Chest", "Shoulders", "Core"],
        videoUrl: exerciseVideos["G87DoorSmash"],
        image: null
    },

    "TriangleOverheadPress": {
        title: "Triangle Overhead Press",
        description: "An overhead pressing movement using triangle resistance bands.",
        steps: [
            "Stand on the band with feet shoulder-width apart.",
            "Hold the triangle handles at shoulder height.",
            "Press the handles overhead until arms are fully extended.",
            "Lower back to shoulder height with control.",
            "Repeat for desired repetitions."
        ],
        tips: [
            "Keep your core tight to prevent back arching.",
            "Don't press the weight behind your head.",
            "Maintain neutral wrist position.",
            "Keep your feet planted firmly."
        ],
        muscleGroups: ["Shoulders", "Triceps", "Core"],
        videoUrl: exerciseVideos["TriangleOverheadPress"],
        image: null
    },

    "TriangleWideFly": {
        title: "Triangle Wide Fly",
        description: "A chest fly exercise using triangle bands to target the pectoral muscles.",
        steps: [
            "Anchor the band at chest height.",
            "Hold the triangle handles with arms extended wide.",
            "Bring your hands together in front of your chest.",
            "Slowly open your arms back to the starting position.",
            "Keep a slight bend in your elbows throughout."
        ],
        tips: [
            "Focus on the stretch in your chest muscles.",
            "Don't let the band snap back quickly.",
            "Keep your shoulders down and back.",
            "Maintain good posture throughout."
        ],
        muscleGroups: ["Chest", "Shoulders"],
        videoUrl: exerciseVideos["TriangleWideFly"],
        image: null
    },

    "TriangleTorso": {
        title: "Triangle Torso Exercise",
        description: "A core-focused exercise using triangle bands for torso rotation and stability.",
        steps: [
            "Hold the triangle band at chest level.",
            "Stand with feet shoulder-width apart.",
            "Rotate your torso while maintaining band tension.",
            "Return to center position with control.",
            "Repeat on both sides."
        ],
        tips: [
            "Keep your hips facing forward.",
            "Engage your core throughout the movement.",
            "Move slowly and with control.",
            "Don't use momentum to rotate."
        ],
        muscleGroups: ["Core", "Obliques", "Shoulders"],
        videoUrl: exerciseVideos["TriangleTorso"],
        image: null
    },

    // ===== CORE BAND EXERCISES =====
    "G87BentRow": {
        title: "G87 Bent Over Row",
        description: "A rowing exercise using resistance bands to target the back muscles.",
        steps: [
            "Stand on the band with feet hip-width apart.",
            "Hold the handles with an overhand grip.",
            "Hinge at the hips and lean forward slightly.",
            "Pull the handles toward your lower ribs.",
            "Slowly lower back to the starting position."
        ],
        tips: [
            "Keep your back straight and chest up.",
            "Squeeze your shoulder blades together.",
            "Don't use momentum to pull the band.",
            "Keep your elbows close to your body."
        ],
        muscleGroups: ["Lats", "Rhomboids", "Middle Traps", "Biceps"],
        videoUrl: exerciseVideos["G87BentRow"],
        image: null
    },

    "G87FlyBack": {
        title: "G87 Reverse Fly",
        description: "A reverse fly movement targeting the posterior deltoids and upper back.",
        steps: [
            "Hold the band at chest level with arms extended.",
            "Keep a slight bend in your elbows.",
            "Pull your arms back and apart, squeezing your shoulder blades.",
            "Slowly return to the starting position.",
            "Maintain tension throughout the movement."
        ],
        tips: [
            "Focus on squeezing your shoulder blades together.",
            "Don't let your shoulders roll forward.",
            "Keep the movement slow and controlled.",
            "Imagine trying to pinch a pencil between your shoulder blades."
        ],
        muscleGroups: ["Rear Delts", "Rhomboids", "Middle Traps"],
        videoUrl: exerciseVideos["G87FlyBack"],
        image: null
    },

    "TriangleOneArmRow": {
        title: "Triangle One Arm Row",
        description: "A unilateral rowing exercise using triangle bands for balanced strength development.",
        steps: [
            "Anchor the band at a low point.",
            "Hold one triangle handle with your working arm.",
            "Step back to create tension in the band.",
            "Pull the handle toward your lower ribs.",
            "Slowly return to the starting position."
        ],
        tips: [
            "Keep your torso stable and avoid rotation.",
            "Focus on pulling with your back muscles, not your arm.",
            "Keep your shoulder blade pulled back.",
            "Work both sides equally."
        ],
        muscleGroups: ["Lats", "Rhomboids", "Middle Traps", "Biceps"],
        videoUrl: exerciseVideos["TriangleOneArmRow"],
        image: null
    },

    "G87SuperWideChop": {
        title: "G87 Super Wide Chop",
        description: "A dynamic chopping movement using resistance bands for core and functional strength.",
        steps: [
            "Anchor the band at a high point to one side.",
            "Hold the handle with both hands above one shoulder.",
            "Pull the band down and across your body to the opposite hip.",
            "Control the return to the starting position.",
            "Complete all reps on one side before switching."
        ],
        tips: [
            "Engage your core throughout the entire movement.",
            "Keep your feet planted and rotate from your torso.",
            "Don't let the band snap back quickly.",
            "Focus on the diagonal movement pattern."
        ],
        muscleGroups: ["Core", "Obliques", "Shoulders", "Lats"],
        videoUrl: exerciseVideos["G87SuperWideChop"],
        image: null
    },

    "G87WideGripBentRow": {
        title: "G87 Wide Grip Bent Row",
        description: "A bent over row with a wider grip to target different areas of the back.",
        steps: [
            "Stand on the band with feet hip-width apart.",
            "Hold the handles with a wide overhand grip.",
            "Hinge at the hips and lean forward.",
            "Pull the handles toward your upper chest.",
            "Slowly lower back to the starting position."
        ],
        tips: [
            "The wider grip targets more upper back muscles.",
            "Keep your elbows flared slightly wider.",
            "Maintain a strong, straight back position.",
            "Focus on squeezing your upper back muscles."
        ],
        muscleGroups: ["Upper Traps", "Rhomboids", "Rear Delts", "Biceps"],
        videoUrl: exerciseVideos["G87WideGripBentRow"],
        image: null
    },

    // ===== ARM BAND EXERCISES =====
    "TriangleFloorCrusher": {
        title: "Triangle Floor Crusher",
        description: "A floor-based crushing movement using triangle bands for chest and arm strength.",
        steps: [
            "Lie on the floor with the band anchored above you.",
            "Hold the triangle handles with arms extended.",
            "Bring your hands together with a crushing motion.",
            "Slowly return to the starting position.",
            "Focus on squeezing throughout the movement."
        ],
        tips: [
            "Keep your core engaged to protect your lower back.",
            "Don't let your arms drop too low.",
            "Focus on the crushing motion rather than pressing.",
            "Control both the positive and negative phases."
        ],
        muscleGroups: ["Chest", "Triceps", "Shoulders"],
        videoUrl: exerciseVideos["TriangleFloorCrusher"],
        image: null
    },

    "TriangleJet": {
        title: "Triangle Jet",
        description: "A dynamic pushing movement using triangle bands to simulate jet-like motion.",
        steps: [
            "Hold the triangle band at chest level.",
            "Stand with feet shoulder-width apart.",
            "Push the band forward with explosive force.",
            "Control the return to the starting position.",
            "Maintain balance throughout the movement."
        ],
        tips: [
            "Engage your core for stability.",
            "Keep your shoulders square and level.",
            "Don't lean forward excessively.",
            "Focus on explosive forward movement."
        ],
        muscleGroups: ["Chest", "Shoulders", "Triceps", "Core"],
        videoUrl: exerciseVideos["TriangleJet"],
        image: null
    },

    "TriangleLiftAndPunch": {
        title: "Triangle Lift and Punch",
        description: "A combination movement involving lifting and punching motions with triangle bands.",
        steps: [
            "Start with the band anchored at a low point.",
            "Hold the triangle handles at your sides.",
            "Lift the handles up while stepping into a punch position.",
            "Punch forward with alternating arms.",
            "Return to the starting position with control."
        ],
        tips: [
            "Coordinate the lifting and punching motions smoothly.",
            "Keep your core engaged throughout.",
            "Don't rush through the movement.",
            "Focus on proper form over speed."
        ],
        muscleGroups: ["Shoulders", "Chest", "Core", "Arms"],
        videoUrl: exerciseVideos["TriangleLiftAndPunch"],
        image: null
    },

    "TriangleLiftOff": {
        title: "Triangle Lift Off",
        description: "An explosive lifting movement using triangle bands for power development.",
        steps: [
            "Start in a low position holding the triangle handles.",
            "Stand on the band or anchor it at a low point.",
            "Explosively lift the handles overhead.",
            "Control the descent back to the starting position.",
            "Focus on generating power from your legs and core."
        ],
        tips: [
            "Use your legs to generate initial power.",
            "Keep the movement explosive but controlled.",
            "Don't let the band snap back quickly.",
            "Maintain good posture throughout."
        ],
        muscleGroups: ["Shoulders", "Legs", "Core", "Upper Back"],
        videoUrl: exerciseVideos["TriangleLiftOff"],
        image: null
    },

    "TriangleOneArmTwist": {
        title: "Triangle One Arm Twist",
        description: "A unilateral twisting movement using triangle bands for core and shoulder stability.",
        steps: [
            "Hold one triangle handle with your working arm.",
            "Anchor the band at chest height.",
            "Start with your arm across your body.",
            "Twist and pull the band away from your body.",
            "Control the return to the starting position."
        ],
        tips: [
            "Keep your core engaged to control the twist.",
            "Don't let your torso rotate excessively.",
            "Focus on smooth, controlled movement.",
            "Work both sides equally."
        ],
        muscleGroups: ["Core", "Obliques", "Shoulders", "Arms"],
        videoUrl: exerciseVideos["TriangleOneArmTwist"],
        image: null
    },

    "TrianglePunchDefend": {
        title: "Triangle Punch Defend",
        description: "A defensive punching movement using triangle bands for functional strength.",
        steps: [
            "Hold the triangle handles in a fighting stance.",
            "Anchor the band behind you at chest height.",
            "Alternate punching forward with each arm.",
            "Pull back to a defensive position between punches.",
            "Maintain balance and stability throughout."
        ],
        tips: [
            "Keep your stance wide and balanced.",
            "Engage your core with each punch.",
            "Don't overextend your punches.",
            "Focus on quick, controlled movements."
        ],
        muscleGroups: ["Shoulders", "Chest", "Core", "Arms"],
        videoUrl: exerciseVideos["TrianglePunchDefend"],
        image: null
    },

    "TriangleUpsideDownPull": {
        title: "Triangle Upside Down Pull",
        description: "An inverted pulling movement using triangle bands for unique muscle activation.",
        steps: [
            "Anchor the band overhead.",
            "Hold the triangle handles with arms extended upward.",
            "Pull the handles down and apart.",
            "Control the return to the starting position.",
            "Maintain tension throughout the movement."
        ],
        tips: [
            "Keep your shoulders down and back.",
            "Don't let the band snap back quickly.",
            "Focus on squeezing your back muscles.",
            "Maintain good posture throughout."
        ],
        muscleGroups: ["Lats", "Rhomboids", "Rear Delts", "Biceps"],
        videoUrl: exerciseVideos["TriangleUpsideDownPull"],
        image: null
    },

    // ===== RESISTANCE BAND EXERCISES =====
    "G87ReverseCurl": {
        title: "G87 Reverse Curl",
        description: "A bicep curl with reverse grip to target the forearms and biceps differently.",
        steps: [
            "Stand on the band with feet hip-width apart.",
            "Hold the handles with an overhand (reverse) grip.",
            "Keep your elbows close to your sides.",
            "Curl the handles up toward your shoulders.",
            "Slowly lower back to the starting position."
        ],
        tips: [
            "Keep your wrists straight and strong.",
            "Don't swing or use momentum.",
            "Focus on the squeeze at the top.",
            "The reverse grip emphasizes forearm muscles."
        ],
        muscleGroups: ["Forearms", "Biceps", "Brachialis"],
        videoUrl: exerciseVideos["G87ReverseCurl"],
        image: null
    },

    "G87OneArmPunch": {
        title: "G87 One Arm Punch",
        description: "A unilateral punching movement using resistance bands for functional strength.",
        steps: [
            "Anchor the band behind you at chest height.",
            "Hold one handle in your working hand.",
            "Start with your arm pulled back in a loaded position.",
            "Punch forward explosively.",
            "Control the return to the starting position."
        ],
        tips: [
            "Keep your core engaged for stability.",
            "Don't overextend your punch.",
            "Focus on explosive forward movement.",
            "Work both arms equally."
        ],
        muscleGroups: ["Chest", "Shoulders", "Triceps", "Core"],
        videoUrl: exerciseVideos["G87OneArmPunch"],
        image: null
    },

    "G87WideGripReverseCurl": {
        title: "G87 Wide Grip Reverse Curl",
        description: "A reverse curl with wider grip to target forearms and outer biceps.",
        steps: [
            "Stand on the band with feet hip-width apart.",
            "Hold the handles with a wide overhand grip.",
            "Keep your elbows close to your sides.",
            "Curl the handles up toward your shoulders.",
            "Slowly lower back to the starting position."
        ],
        tips: [
            "The wide grip targets different forearm muscles.",
            "Keep your wrists strong throughout the movement.",
            "Don't swing or use momentum.",
            "Focus on controlled movement in both directions."
        ],
        muscleGroups: ["Forearms", "Biceps", "Brachialis"],
        videoUrl: exerciseVideos["G87WideGripReverseCurl"],
        image: null
    },

    "G87WideStraightBarCurl": {
        title: "G87 Wide Straight Bar Curl",
        description: "A bicep curl using a wide grip on the resistance band for outer bicep emphasis.",
        steps: [
            "Stand on the band with feet hip-width apart.",
            "Hold the band with a wide underhand grip.",
            "Keep your elbows close to your sides.",
            "Curl the band up toward your chest.",
            "Slowly lower back to the starting position."
        ],
        tips: [
            "The wide grip emphasizes the outer head of the biceps.",
            "Keep your shoulders back and down.",
            "Don't let your elbows drift forward.",
            "Squeeze your biceps at the top of the movement."
        ],
        muscleGroups: ["Biceps", "Forearms"],
        videoUrl: exerciseVideos["G87WideStraightBarCurl"],
        image: null
    },
    "G87OneArmOverheadPress": {
        title: "G87 One Arm Overhead Press",
        description: "A unilateral overhead pressing exercise using G87 resistance bands.",
        steps: [
            "Stand on the resistance band with one foot.",
            "Hold one handle with your working arm at shoulder height.",
            "Keep your core tight and maintain good posture.",
            "Press the handle straight up overhead until your arm is fully extended.",
            "Lower back to shoulder height with control.",
            "Complete all reps before switching arms."
        ],
        tips: [
            "Keep your core engaged to prevent back arching.",
            "Don't press the weight behind your head.",
            "Maintain neutral wrist position throughout.",
            "Work both arms equally to prevent imbalances.",
            "The single-arm version challenges core stability more."
        ],
        muscleGroups: ["Shoulders", "Triceps", "Core"],
        videoUrl: exerciseVideos["G87OneArmOverheadPress"],
        image: null
    },

    "G87SeatedFrenchPress": {
        title: "G87 Seated French Press",
        description: "A seated tricep exercise using resistance bands for overhead extension.",
        steps: [
            "Sit on the band or anchor it under your chair.",
            "Hold the handles overhead with both hands.",
            "Keep your elbows close to your head.",
            "Lower the handles behind your head by bending your elbows.",
            "Press back up to the starting position."
        ],
        tips: [
            "Keep your upper arms stationary throughout.",
            "Don't let your elbows flare out to the sides.",
            "Focus on isolating the tricep muscles.",
            "Control the movement in both directions."
        ],
        muscleGroups: ["Triceps"],
        videoUrl: exerciseVideos["G87SeatedFrenchPress"],
        image: null
    },

    "TriangleSlowCurl": {
        title: "Triangle Slow Curl",
        description: "A controlled bicep curl using triangle bands for maximum muscle tension.",
        steps: [
            "Stand on the triangle band with feet hip-width apart.",
            "Hold the handles with an underhand grip.",
            "Slowly curl the handles up taking 3-4 seconds.",
            "Pause at the top and squeeze your biceps.",
            "Slowly lower back down taking 3-4 seconds."
        ],
        tips: [
            "The slow tempo increases time under tension.",
            "Focus on feeling the muscle work throughout the range.",
            "Don't use momentum - make the muscles do all the work.",
            "Keep your core engaged for stability."
        ],
        muscleGroups: ["Biceps", "Forearms"],
        videoUrl: exerciseVideos["TriangleSlowCurl"],
        image: null
    },

    "TriangleTiltAndPour": {
        title: "Triangle Tilt and Pour",
        description: "A unique forearm and wrist exercise using triangle bands for rotational strength.",
        steps: [
            "Hold the triangle handles at your sides.",
            "Keep your elbows at 90 degrees.",
            "Rotate your wrists as if pouring water from a pitcher.",
            "Tilt in one direction, then the other.",
            "Control the movement throughout the range."
        ],
        tips: [
            "This targets the often-neglected rotational muscles.",
            "Move slowly and focus on control.",
            "Don't use your shoulders - isolate the forearms.",
            "This exercise helps prevent wrist injuries."
        ],
        muscleGroups: ["Forearms", "Wrists"],
        videoUrl: exerciseVideos["TriangleTiltAndPour"],
        image: null
    },

    "G87ReverseWristCurl": {
        title: "G87 Reverse Wrist Curl",
        description: "A wrist extension exercise using resistance bands for forearm balance.",
        steps: [
            "Sit with your forearms resting on your thighs.",
            "Hold the band handles with palms facing down.",
            "Let your wrists hang over your knees.",
            "Lift your wrists up by extending your forearms.",
            "Lower back down with control."
        ],
        tips: [
            "Use lighter resistance than regular wrist curls.",
            "The extensor muscles are typically weaker.",
            "Focus on full range of motion.",
            "This helps balance forearm strength."
        ],
        muscleGroups: ["Forearm Extensors"],
        videoUrl: exerciseVideos["G87ReverseWristCurl"],
        image: null
    },

    // ===== SHOULDER BAND EXERCISES =====
    "G87StepWide": {
        title: "G87 Step Wide",
        description: "A lateral stepping exercise with resistance bands for hip and shoulder engagement.",
        steps: [
            "Step on the band with one foot.",
            "Hold the handles at shoulder height.",
            "Step wide to the side while maintaining band tension.",
            "Bring your arms out to the sides as you step.",
            "Return to the starting position with control."
        ],
        tips: [
            "Keep your core engaged throughout the movement.",
            "Don't let the band snap back quickly.",
            "Focus on coordinating the step with the arm movement.",
            "This exercise improves lateral stability."
        ],
        muscleGroups: ["Shoulders", "Hips", "Core", "Legs"],
        videoUrl: exerciseVideos["G87StepWide"],
        image: null
    },

    "TriangleRocket": {
        title: "Triangle Rocket",
        description: "An explosive upward movement using triangle bands for power development.",
        steps: [
            "Start in a low squat position holding the triangle handles.",
            "Anchor the band under your feet or at a low point.",
            "Explosively drive up while pressing the handles overhead.",
            "Extend your body like a rocket launching.",
            "Control the descent back to the starting position."
        ],
        tips: [
            "Use your legs to generate initial power.",
            "Keep the movement explosive but controlled.",
            "Fully extend your body at the top.",
            "This combines lower and upper body power."
        ],
        muscleGroups: ["Shoulders", "Legs", "Core", "Full Body"],
        videoUrl: exerciseVideos["TriangleRocket"],
        image: null
    },

    "TriangleWings": {
        title: "Triangle Wings",
        description: "A rear deltoid and upper back exercise using triangle bands with wing-like motion.",
        steps: [
            "Hold the triangle handles at chest level.",
            "Start with arms extended forward.",
            "Pull your arms back and apart like spreading wings.",
            "Squeeze your shoulder blades together.",
            "Slowly return to the starting position."
        ],
        tips: [
            "Focus on squeezing your shoulder blades together.",
            "Keep a slight bend in your elbows.",
            "Don't let your shoulders roll forward.",
            "Imagine you're trying to fly with your arms."
        ],
        muscleGroups: ["Rear Delts", "Rhomboids", "Middle Traps"],
        videoUrl: exerciseVideos["TriangleWings"],
        image: null
    },

    "TriangleUprightRow": {
        title: "Triangle Upright Row",
        description: "An upright rowing movement using triangle bands for shoulder and trap development.",
        steps: [
            "Stand on the triangle band with feet hip-width apart.",
            "Hold the handles with an overhand grip, hands close together.",
            "Pull the handles up along your body toward your chin.",
            "Keep your elbows higher than your hands.",
            "Lower back down with control."
        ],
        tips: [
            "Don't pull too high - stop at chest level if you feel shoulder discomfort.",
            "Keep the handles close to your body.",
            "Focus on lifting with your elbows.",
            "This exercise targets the traps and front delts."
        ],
        muscleGroups: ["Shoulders", "Traps", "Biceps"],
        videoUrl: exerciseVideos["TriangleUprightRow"],
        image: null
    },

    // ===== PUSH-UP VARIATIONS =====
    "PushUps": {
        title: "Push Ups",
        description: "A classic bodyweight exercise that targets the chest, shoulders, and triceps.",
        steps: [
            "Start in a plank position with your hands slightly wider than shoulder-width apart.",
            "Keep your body in a straight line from head to heels.",
            "Lower your body until your chest nearly touches the floor.",
            "Push yourself back up to the starting position.",
            "Repeat for the desired number of repetitions."
        ],
        tips: [
            "Keep your core engaged throughout the movement.",
            "Don't let your hips sag or pike up.",
            "If regular push-ups are too difficult, try doing them from your knees.",
            "For more challenge, try elevating your feet."
        ],
        muscleGroups: ["Chest", "Shoulders", "Triceps", "Core"],
        videoUrl: exerciseVideos["PushUps"],
        image: null
    },

    "ClappingPushUps": {
        title: "Clapping Push Ups",
        description: "An explosive variation of push-ups that adds a clap at the top for increased power and difficulty.",
        steps: [
            "Start in a standard push-up position.",
            "Lower your body to the floor as in a regular push-up.",
            "Explosively push up with enough force to lift your hands off the ground.",
            "Clap your hands together while airborne.",
            "Land with your hands back in position and immediately lower into the next rep."
        ],
        tips: [
            "Build up to this exercise with regular push-ups first.",
            "Land softly to protect your wrists.",
            "Start with just lifting your hands, then progress to clapping.",
            "Focus on explosive power from the bottom position."
        ],
        muscleGroups: ["Chest", "Shoulders", "Triceps", "Core"],
        videoUrl: exerciseVideos["ClappingPushUps"],
        image: null
    },

    "DeclinePushUps": {
        title: "Decline Push Ups",
        description: "Push-ups performed with feet elevated to increase difficulty and target upper chest.",
        steps: [
            "Place your feet on an elevated surface (bench, chair, or step).",
            "Position your hands on the ground slightly wider than shoulder-width.",
            "Keep your body in a straight line from head to heels.",
            "Lower your chest toward the ground.",
            "Push back up to the starting position."
        ],
        tips: [
            "The higher the elevation, the more difficult the exercise.",
            "Keep your core tight to prevent sagging.",
            "This variation emphasizes the upper chest and shoulders.",
            "Start with a low elevation and progress higher."
        ],
        muscleGroups: ["Upper Chest", "Shoulders", "Triceps", "Core"],
        videoUrl: exerciseVideos["DeclinePushUps"],
        image: null
    },

    "DiveBombers": {
        title: "Dive Bomber Push Ups",
        description: "A dynamic push-up variation that incorporates a diving and climbing motion.",
        steps: [
            "Start in a downward dog position with hips high.",
            "Dive forward and down, leading with your head.",
            "Scoop your chest through your arms close to the ground.",
            "Finish in an upward dog position with chest up.",
            "Reverse the movement to return to the starting position."
        ],
        tips: [
            "Keep the movement fluid and controlled.",
            "Don't let your hips drop too low during the scoop.",
            "This exercise combines strength and mobility.",
            "Start slowly and focus on proper form."
        ],
        muscleGroups: ["Chest", "Shoulders", "Triceps", "Core", "Back"],
        videoUrl: exerciseVideos["DiveBombers"],
        image: null
    },

    "HandReleasePushUps": {
        title: "Hand Release Push Ups",
        description: "Push-ups where you lift your hands off the ground at the bottom to eliminate momentum.",
        steps: [
            "Start in a standard push-up position.",
            "Lower your body all the way to the ground.",
            "Lift your hands off the ground for a moment.",
            "Place your hands back down and push up to the starting position.",
            "Repeat for desired repetitions."
        ],
        tips: [
            "This eliminates the stretch reflex and makes each rep harder.",
            "Focus on pressing the ground away from you.",
            "Keep your body rigid throughout the movement.",
            "Don't rush the hand release portion."
        ],
        muscleGroups: ["Chest", "Shoulders", "Triceps", "Core"],
        videoUrl: exerciseVideos["HandReleasePushUps"],
        image: null
    },

    "PushUpsClose": {
        title: "Close Grip Push Ups",
        description: "Push-ups with hands closer together to emphasize triceps development.",
        steps: [
            "Start in a push-up position with hands closer together than shoulder-width.",
            "Form a diamond or triangle shape with your hands (optional).",
            "Lower your body while keeping elbows close to your sides.",
            "Push back up to the starting position.",
            "Focus on triceps engagement."
        ],
        tips: [
            "This variation is harder than regular push-ups.",
            "Keep your elbows tucked close to your body.",
            "You may need to do fewer reps initially.",
            "Diamond push-ups are the most challenging version."
        ],
        muscleGroups: ["Triceps", "Chest", "Shoulders", "Core"],
        videoUrl: exerciseVideos["PushUpsClose"],
        image: null
    },

    "PushUpsWide": {
        title: "Wide Grip Push Ups",
        description: "Push-ups with hands placed wider than normal to target outer chest muscles.",
        steps: [
            "Start in a push-up position with hands wider than shoulder-width.",
            "Keep your body in a straight line.",
            "Lower your body toward the ground.",
            "Push back up to the starting position.",
            "Focus on feeling the stretch in your chest."
        ],
        tips: [
            "Don't go too wide as it can stress the shoulders.",
            "This variation emphasizes the outer chest muscles.",
            "Keep your core tight throughout.",
            "Lower yourself only as far as comfortable."
        ],
        muscleGroups: ["Outer Chest", "Shoulders", "Triceps", "Core"],
        videoUrl: exerciseVideos["PushUpsWide"],
        image: null
    },

    "PushUpsSpiderman": {
        title: "Spiderman Push Ups",
        description: "Push-ups combined with knee-to-elbow movement for added core engagement.",
        steps: [
            "Start in a standard push-up position.",
            "As you lower down, bring one knee toward the elbow on the same side.",
            "Push back up while returning your leg to the starting position.",
            "Alternate legs with each repetition.",
            "Keep your core engaged throughout."
        ],
        tips: [
            "This adds significant core and hip flexor work.",
            "Don't let your hips rotate during the movement.",
            "Start slowly to master the coordination.",
            "Focus on bringing knee to elbow, not elbow to knee."
        ],
        muscleGroups: ["Chest", "Shoulders", "Triceps", "Core", "Hip Flexors"],
        videoUrl: exerciseVideos["PushUpsSpiderman"],
        image: null
    },

    "SpartanPushUps": {
        title: "Spartan Push Ups",
        description: "A challenging push-up variation with alternating hand positions.",
        steps: [
            "Start with one hand forward and one hand back in a staggered position.",
            "Perform a push-up in this position.",
            "At the top, explosively switch your hand positions.",
            "Perform another push-up with hands in the new position.",
            "Continue alternating hand positions."
        ],
        tips: [
            "This requires significant upper body strength and coordination.",
            "Start with slow hand switches before making them explosive.",
            "Keep your core tight to maintain stability.",
            "This exercise also works balance and proprioception."
        ],
        muscleGroups: ["Chest", "Shoulders", "Triceps", "Core"],
        videoUrl: exerciseVideos["SpartanPushUps"],
        image: null
    },

    "DiamondPushUps": {
        title: "Diamond Push Ups",
        description: "Push-ups with hands forming a diamond shape to emphasize triceps.",
        steps: [
            "Start in a push-up position with hands close together.",
            "Form a diamond or triangle shape with your thumbs and index fingers.",
            "Lower your body toward your hands.",
            "Keep your elbows close to your body.",
            "Push back up to the starting position."
        ],
        tips: [
            "This is significantly harder than regular push-ups.",
            "Focus on keeping your elbows tucked in.",
            "You may need to do fewer reps initially.",
            "This variation heavily emphasizes the triceps."
        ],
        muscleGroups: ["Triceps", "Chest", "Shoulders", "Core"],
        videoUrl: exerciseVideos["DiamondPushUps"],
        image: null
    },

    "PikePushUps": {
        title: "Pike Push Ups",
        description: "Push-ups in a pike position to target the shoulders more directly.",
        steps: [
            "Start in a downward dog or pike position with hips high.",
            "Place your hands shoulder-width apart on the ground.",
            "Lower your head toward the ground by bending your elbows.",
            "Push back up to the starting pike position.",
            "Keep your legs as straight as possible."
        ],
        tips: [
            "This primarily targets the shoulders rather than chest.",
            "The higher your feet, the more challenging it becomes.",
            "This is a progression toward handstand push-ups.",
            "Focus on lowering your head straight down, not forward."
        ],
        muscleGroups: ["Shoulders", "Triceps", "Upper Chest", "Core"],
        videoUrl: exerciseVideos["PikePushUps"],
        image: null
    },

    "ElevatedPushUps": {
        title: "Elevated Push Ups",
        description: "Push-ups with hands elevated to make the exercise easier for beginners.",
        steps: [
            "Place your hands on an elevated surface (bench, step, wall).",
            "Keep your body in a straight line from head to heels.",
            "Lower your chest toward the elevated surface.",
            "Push back up to the starting position.",
            "The higher the surface, the easier the exercise."
        ],
        tips: [
            "This is perfect for building up to regular push-ups.",
            "Gradually lower the height as you get stronger.",
            "Maintain perfect form throughout.",
            "Even wall push-ups are a valid starting point."
        ],
        muscleGroups: ["Chest", "Shoulders", "Triceps", "Core"],
        videoUrl: exerciseVideos["ElevatedPushUps"],
        image: null
    },

    // ===== BACK EXERCISES =====
    "BackExtensions": {
        title: "Back Extensions",
        description: "An exercise to strengthen the lower back and posterior chain muscles.",
        steps: [
            "Lie face down on the floor with your hands behind your head.",
            "Keep your legs and hips pressed to the ground.",
            "Lift your chest and head off the ground by contracting your back muscles.",
            "Hold briefly at the top.",
            "Lower back down with control."
        ],
        tips: [
            "Don't hyperextend your back - lift only as high as comfortable.",
            "Focus on using your back muscles, not your arms.",
            "Keep your neck in a neutral position.",
            "Start with small ranges of motion."
        ],
        muscleGroups: ["Lower Back", "Glutes", "Hamstrings"],
        videoUrl: exerciseVideos["BackExtensions"],
        image: null
    },

    "ChinUps": {
        title: "Chin Ups",
        description: "A pulling exercise using an underhand grip to target biceps and back muscles.",
        steps: [
            "Hang from a pull-up bar with an underhand (supinated) grip.",
            "Start with arms fully extended and shoulders engaged.",
            "Pull yourself up until your chin clears the bar.",
            "Lower yourself back down with control.",
            "Repeat for desired repetitions."
        ],
        tips: [
            "The underhand grip emphasizes biceps more than pull-ups.",
            "Don't swing or use momentum.",
            "Focus on pulling with your back muscles.",
            "If too difficult, use resistance bands for assistance."
        ],
        muscleGroups: ["Biceps", "Lats", "Rhomboids", "Middle Traps"],
        videoUrl: exerciseVideos["ChinUps"],
        image: null
    },

    "ChinUpsOneArmLeft": {
        title: "One Arm Chin Ups (Left)",
        description: "An advanced unilateral pulling exercise using only the left arm.",
        steps: [
            "Hang from a pull-up bar using only your left hand.",
            "Keep your right arm at your side or across your body.",
            "Pull yourself up until your chin clears the bar.",
            "Lower yourself down with control.",
            "This is an extremely advanced exercise."
        ],
        tips: [
            "This requires exceptional upper body strength.",
            "Work up to this with assisted one-arm variations first.",
            "Use proper progressions including negative reps.",
            "Consider using a towel or rope for the non-working hand initially."
        ],
        muscleGroups: ["Biceps", "Lats", "Rhomboids", "Forearms"],
        videoUrl: exerciseVideos["ChinUpsOneArmLeft"],
        image: null
    },

    "DoubleDumbbellRows": {
        title: "Double Dumbbell Rows",
        description: "A rowing exercise using two dumbbells simultaneously to target the back muscles.",
        steps: [
            "Hold a dumbbell in each hand with feet hip-width apart.",
            "Hinge at the hips and lean forward with a straight back.",
            "Let the dumbbells hang at arm's length.",
            "Pull both dumbbells up to your lower ribs simultaneously.",
            "Lower the weights back down with control."
        ],
        tips: [
            "Keep your back straight and core engaged.",
            "Pull with your back muscles, not just your arms.",
            "Squeeze your shoulder blades together at the top.",
            "Don't let the weights swing or use momentum."
        ],
        muscleGroups: ["Lats", "Rhomboids", "Middle Traps", "Biceps"],
        videoUrl: exerciseVideos["DoubleDumbbellRows"],
        image: null
    },

    "DumbbellRows": {
        title: "Single Dumbbell Rows",
        description: "A unilateral rowing exercise to build back strength and address imbalances.",
        steps: [
            "Place one knee and hand on a bench for support.",
            "Hold a dumbbell in the opposite hand.",
            "Let the dumbbell hang at arm's length.",
            "Pull the dumbbell up to your lower ribs.",
            "Lower back down with control and repeat."
        ],
        tips: [
            "Keep your back flat and parallel to the ground.",
            "Pull the weight to your hip, not your chest.",
            "Focus on squeezing your shoulder blade back.",
            "Don't rotate your torso during the movement."
        ],
        muscleGroups: ["Lats", "Rhomboids", "Middle Traps", "Biceps"],
        videoUrl: exerciseVideos["DumbbellRows"],
        image: null
    },

    "ExplosiveRows": {
        title: "Explosive Rows",
        description: "Fast, powerful rowing movements to develop explosive pulling strength.",
        steps: [
            "Set up in a bent-over rowing position.",
            "Start with weights at arm's length.",
            "Explosively pull the weights up to your ribs.",
            "Control the descent back to the starting position.",
            "Focus on maximum speed on the pulling phase."
        ],
        tips: [
            "Maintain perfect form despite the explosive movement.",
            "Use lighter weights than regular rows initially.",
            "Focus on speed of contraction, not just weight moved.",
            "Keep your core tight to protect your back."
        ],
        muscleGroups: ["Lats", "Rhomboids", "Middle Traps", "Biceps"],
        videoUrl: exerciseVideos["ExplosiveRows"],
        image: null
    },

    "InvertedRowsWithChairs": {
        title: "Inverted Rows with Chairs",
        description: "A bodyweight rowing exercise using chairs for support.",
        steps: [
            "Place a sturdy bar or broomstick between two chairs.",
            "Lie under the bar and grab it with an overhand grip.",
            "Keep your body straight from head to heels.",
            "Pull your chest up to the bar.",
            "Lower back down with control."
        ],
        tips: [
            "Make sure the setup is stable and secure.",
            "Keep your body in a straight line throughout.",
            "The higher the bar, the easier the exercise.",
            "This is a great progression toward pull-ups."
        ],
        muscleGroups: ["Lats", "Rhomboids", "Middle Traps", "Biceps"],
        videoUrl: exerciseVideos["InvertedRowsWithChairs"],
        image: null
    },

    "NegativePullUps": {
        title: "Negative Pull Ups",
        description: "The eccentric portion of pull-ups to build strength for full pull-ups.",
        steps: [
            "Jump or step up to the top position of a pull-up.",
            "Start with your chin above the bar.",
            "Slowly lower yourself down, taking 3-5 seconds.",
            "Control the descent as much as possible.",
            "Reset and repeat."
        ],
        tips: [
            "Focus on controlling the lowering phase.",
            "This builds strength for full pull-ups effectively.",
            "Take your time - the slower the better.",
            "Use a step or jump to get to the top position."
        ],
        muscleGroups: ["Lats", "Rhomboids", "Biceps", "Forearms"],
        videoUrl: exerciseVideos["NegativePullUps"],
        image: null
    },

    "PullUpsBarHold": {
        title: "Pull Up Bar Hold",
        description: "An isometric exercise to build grip strength and upper body endurance.",
        steps: [
            "Hang from a pull-up bar with arms fully extended.",
            "Use an overhand grip slightly wider than shoulder-width.",
            "Keep your shoulders engaged, not completely relaxed.",
            "Hold this position for as long as possible.",
            "Focus on maintaining good form throughout."
        ],
        tips: [
            "Start with shorter holds and gradually increase time.",
            "Keep your shoulders slightly pulled down and back.",
            "This builds grip strength and prepares you for pull-ups.",
            "Don't let your shoulders completely relax and shrug up."
        ],
        muscleGroups: ["Forearms", "Lats", "Shoulders"],
        videoUrl: exerciseVideos["PullUpsBarHold"],
        image: null
    },

    "PullUps": {
        title: "Pull Ups",
        description: "A fundamental upper body pulling exercise using an overhand grip.",
        steps: [
            "Hang from a pull-up bar with an overhand grip.",
            "Start with arms fully extended.",
            "Pull yourself up until your chin clears the bar.",
            "Lower yourself back down with control.",
            "Keep your core engaged throughout."
        ],
        tips: [
            "Don't swing or use momentum.",
            "Focus on pulling with your back muscles.",
            "If too difficult, use resistance bands for assistance.",
            "Full range of motion is important for best results."
        ],
        muscleGroups: ["Lats", "Rhomboids", "Middle Traps", "Biceps"],
        videoUrl: exerciseVideos["PullUps"],
        image: null
    },

    "AustralianPullUps": {
        title: "Australian Pull Ups",
        description: "Inverted rows performed at an angle to build pulling strength.",
        steps: [
            "Set up a bar at hip height (or use a suspension trainer).",
            "Lie under the bar and grab it with an overhand grip.",
            "Keep your body straight from head to heels.",
            "Pull your chest up to the bar.",
            "Lower back down with control."
        ],
        tips: [
            "The lower the bar, the harder the exercise.",
            "Keep your body in a straight line throughout.",
            "This is an excellent progression toward pull-ups.",
            "Focus on squeezing your shoulder blades together."
        ],
        muscleGroups: ["Lats", "Rhomboids", "Middle Traps", "Biceps"],
        videoUrl: exerciseVideos["AustralianPullUps"],
        image: null
    },
    // ===== SHOULDER EXERCISES =====
    "DumbbellJumpSquats": {
        title: "Dumbbell Jump Squats",
        description: "Explosive squats while holding dumbbells for added resistance and power development.",
        steps: [
            "Hold dumbbells at your sides or at shoulder height.",
            "Stand with feet shoulder-width apart.",
            "Lower into a squat position.",
            "Explosively jump up as high as possible.",
            "Land softly and immediately lower into the next squat."
        ],
        tips: [
            "Start with lighter weights to master the movement.",
            "Focus on landing softly to protect your joints.",
            "Keep your core engaged throughout.",
            "Don't sacrifice form for height or speed."
        ],
        muscleGroups: ["Quadriceps", "Glutes", "Calves", "Shoulders"],
        videoUrl: exerciseVideos["DumbbellJumpSquats"],
        image: null
    },

    "DumbbellSquatsandPress": {
        title: "Dumbbell Squats and Press",
        description: "A compound exercise combining squats with overhead pressing for full-body strength.",
        steps: [
            "Hold dumbbells at shoulder height.",
            "Stand with feet shoulder-width apart.",
            "Lower into a squat position.",
            "As you stand up, press the dumbbells overhead.",
            "Lower the weights back to shoulders and repeat."
        ],
        tips: [
            "Use the momentum from the squat to help with the press.",
            "Keep your core tight throughout the movement.",
            "Don't press the weights behind your head.",
            "This is an excellent full-body exercise."
        ],
        muscleGroups: ["Quadriceps", "Glutes", "Shoulders", "Core"],
        videoUrl: exerciseVideos["DumbbellSquatsandPress"],
        image: null
    },

    "HandstandPushUps": {
        title: "Handstand Push Ups",
        description: "An advanced vertical pushing exercise performed in a handstand position.",
        steps: [
            "Kick up into a handstand against a wall.",
            "Keep your body straight and core engaged.",
            "Lower your head toward the ground.",
            "Press back up to the starting position.",
            "This requires significant strength and balance."
        ],
        tips: [
            "Master wall-supported handstands first.",
            "Start with partial range of motion.",
            "Use a spotter or padding for safety.",
            "This is one of the most challenging upper body exercises."
        ],
        muscleGroups: ["Shoulders", "Triceps", "Upper Chest", "Core"],
        videoUrl: exerciseVideos["HandstandPushUps"],
        image: null
    },

    "OverheadSquatWithDumbbells": {
        title: "Overhead Squat with Dumbbells",
        description: "A challenging squat variation with dumbbells held overhead for stability and strength.",
        steps: [
            "Hold dumbbells overhead with arms fully extended.",
            "Stand with feet shoulder-width apart.",
            "Lower into a squat while keeping the weights overhead.",
            "Keep your chest up and core engaged.",
            "Return to the starting position."
        ],
        tips: [
            "This requires significant shoulder and core stability.",
            "Start with very light weights or no weight at all.",
            "Keep the weights directly over your shoulders.",
            "This exercise improves mobility and stability."
        ],
        muscleGroups: ["Quadriceps", "Glutes", "Shoulders", "Core"],
        videoUrl: exerciseVideos["OverheadSquatWithDumbbells"],
        image: null
    },

    "PushUpJumps": {
        title: "Push Up Jumps",
        description: "Explosive push-ups where you jump your feet in and out during the movement.",
        steps: [
            "Start in a push-up position.",
            "Perform a push-up.",
            "At the top, jump your feet toward your hands.",
            "Jump your feet back to the push-up position.",
            "Repeat the sequence."
        ],
        tips: [
            "Keep your hands planted firmly throughout.",
            "This adds a cardio element to the push-up.",
            "Land softly when jumping your feet.",
            "Maintain good push-up form throughout."
        ],
        muscleGroups: ["Chest", "Shoulders", "Triceps", "Core", "Legs"],
        videoUrl: exerciseVideos["PushUpJumps"],
        image: null
    },

    "ShoulderToFloorStretch": {
        title: "Shoulder to Floor Stretch",
        description: "A stretching exercise to improve shoulder flexibility and mobility.",
        steps: [
            "Lie on your side with your bottom arm extended along the floor.",
            "Place your top hand on the floor in front of you for support.",
            "Gently press your bottom shoulder toward the floor.",
            "Hold the stretch for 20-30 seconds.",
            "Switch sides and repeat."
        ],
        tips: [
            "Don't force the stretch - go only as far as comfortable.",
            "Breathe deeply during the stretch.",
            "This helps improve shoulder internal rotation.",
            "Perform regularly to maintain shoulder flexibility."
        ],
        muscleGroups: ["Shoulders", "Chest"],
        videoUrl: exerciseVideos["ShoulderToFloorStretch"],
        image: null
    },

    "SmallToLargeArmCircles": {
        title: "Small to Large Arm Circles",
        description: "A dynamic warm-up exercise progressing from small to large arm circles.",
        steps: [
            "Stand with arms extended out to your sides.",
            "Start with small circular motions forward.",
            "Gradually increase the size of the circles.",
            "Reverse direction and go from large to small circles backward.",
            "Keep your arms straight throughout."
        ],
        tips: [
            "This is great for warming up the shoulders.",
            "Keep the progression smooth and controlled.",
            "Don't rush through the movement.",
            "Focus on full range of motion in the shoulders."
        ],
        muscleGroups: ["Shoulders", "Upper Back"],
        videoUrl: exerciseVideos["SmallToLargeArmCircles"],
        image: null
    },

    "WallWalkouts": {
        title: "Wall Walkouts",
        description: "A shoulder mobility and strengthening exercise using a wall for support.",
        steps: [
            "Stand arm's length away from a wall.",
            "Place your hands on the wall at shoulder height.",
            "Walk your hands up the wall as high as comfortable.",
            "Hold briefly at the top.",
            "Walk your hands back down to the starting position."
        ],
        tips: [
            "Keep your core engaged throughout the movement.",
            "Don't force the range of motion.",
            "This helps improve shoulder flexion.",
            "Great for rehabilitation and mobility work."
        ],
        muscleGroups: ["Shoulders", "Core"],
        videoUrl: exerciseVideos["WallWalkouts"],
        image: null
    },

    // ===== ARM EXERCISES =====
    "BenchOrChairDips": {
        title: "Bench or Chair Dips",
        description: "A tricep exercise using a bench or chair for support.",
        steps: [
            "Sit on the edge of a bench or chair with hands gripping the edge.",
            "Slide your body off the bench, supporting your weight with your arms.",
            "Lower your body by bending your elbows.",
            "Push back up to the starting position.",
            "Keep your legs extended or bent for different difficulty levels."
        ],
        tips: [
            "Keep your body close to the bench.",
            "Don't lower too far if you feel shoulder discomfort.",
            "Focus on using your triceps, not your legs.",
            "Bent knees make it easier, straight legs harder."
        ],
        muscleGroups: ["Triceps", "Shoulders", "Chest"],
        videoUrl: exerciseVideos["BenchOrChairDips"],
        image: null
    },

    "BicepCurls": {
        title: "Bicep Curls",
        description: "A fundamental arm exercise targeting the bicep muscles.",
        steps: [
            "Hold dumbbells or resistance bands with arms at your sides.",
            "Keep your elbows close to your body.",
            "Curl the weight up toward your shoulders.",
            "Squeeze your biceps at the top.",
            "Lower the weight back down with control."
        ],
        tips: [
            "Don't swing or use momentum.",
            "Keep your wrists straight and strong.",
            "Focus on the muscle contraction.",
            "Control both the lifting and lowering phases."
        ],
        muscleGroups: ["Biceps", "Forearms"],
        videoUrl: exerciseVideos["BicepCurls"],
        image: null
    },

    "ChairTricepExtension": {
        title: "Chair Tricep Extension",
        description: "A tricep extension exercise using a chair for stability and support.",
        steps: [
            "Sit on a chair and hold a weight with both hands overhead.",
            "Keep your elbows close to your head.",
            "Lower the weight behind your head by bending your elbows.",
            "Extend your arms back up to the starting position.",
            "Keep your upper arms stationary throughout."
        ],
        tips: [
            "Don't let your elbows flare out to the sides.",
            "Keep your core engaged for stability.",
            "Use a weight you can control safely overhead.",
            "Focus on isolating the tricep muscles."
        ],
        muscleGroups: ["Triceps"],
        videoUrl: exerciseVideos["ChairTricepExtension"],
        image: null
    },

    "Dips": {
        title: "Dips",
        description: "A compound upper body exercise targeting triceps, chest, and shoulders.",
        steps: [
            "Support yourself on parallel bars or dip station.",
            "Start with arms fully extended.",
            "Lower your body by bending your elbows.",
            "Descend until your shoulders are below your elbows.",
            "Push back up to the starting position."
        ],
        tips: [
            "Lean forward slightly to emphasize chest, stay upright for triceps.",
            "Don't go too low if you feel shoulder discomfort.",
            "Keep your core engaged throughout.",
            "Progress gradually as this is a challenging exercise."
        ],
        muscleGroups: ["Triceps", "Chest", "Shoulders"],
        videoUrl: exerciseVideos["Dips"],
        image: null
    },

    "DipsHoldBottom": {
        title: "Dips Hold Bottom",
        description: "An isometric hold at the bottom position of dips for strength building.",
        steps: [
            "Lower yourself into the bottom position of a dip.",
            "Hold this position with your shoulders below your elbows.",
            "Keep your arms bent and supporting your body weight.",
            "Hold for as long as possible while maintaining good form.",
            "Focus on keeping your shoulders stable."
        ],
        tips: [
            "This builds strength in the most challenging part of the dip.",
            "Don't hold if you feel shoulder pain.",
            "Start with short holds and gradually increase time.",
            "This is an advanced exercise - ensure you can do regular dips first."
        ],
        muscleGroups: ["Triceps", "Chest", "Shoulders"],
        videoUrl: exerciseVideos["DipsHoldBottom"],
        image: null
    },

    "DumbbellKickBacks": {
        title: "Dumbbell Kickbacks",
        description: "An isolation exercise targeting the triceps with a kickback motion.",
        steps: [
            "Hold a dumbbell in one hand and lean forward.",
            "Support yourself with the other hand on a bench.",
            "Keep your upper arm parallel to the floor.",
            "Extend your forearm back until your arm is straight.",
            "Return to the starting position with control."
        ],
        tips: [
            "Keep your upper arm stationary throughout.",
            "Focus on squeezing your tricep at the extension.",
            "Don't use too much weight - form is crucial.",
            "Keep your back straight and core engaged."
        ],
        muscleGroups: ["Triceps"],
        videoUrl: exerciseVideos["DumbbellKickBacks"],
        image: null
    },

    "FrontRackStretch": {
        title: "Front Rack Stretch",
        description: "A stretching exercise to improve shoulder and wrist flexibility for front rack position.",
        steps: [
            "Hold a barbell or dumbbells in the front rack position.",
            "Keep your elbows high and weights resting on your shoulders.",
            "Hold this position to stretch your wrists and shoulders.",
            "Focus on keeping your elbows up and chest proud.",
            "Breathe deeply and relax into the stretch."
        ],
        tips: [
            "This improves mobility for front squats and cleans.",
            "Don't force the position if it's uncomfortable.",
            "Work on wrist and shoulder flexibility separately if needed.",
            "Hold for 30-60 seconds at a time."
        ],
        muscleGroups: ["Shoulders", "Wrists", "Upper Back"],
        videoUrl: exerciseVideos["FrontRackStretch"],
        image: null
    },

    "TricepPress": {
        title: "Tricep Press",
        description: "A pressing exercise specifically targeting the tricep muscles.",
        steps: [
            "Hold a weight overhead with both hands.",
            "Keep your elbows close to your head.",
            "Lower the weight behind your head by bending your elbows.",
            "Press the weight back up to the starting position.",
            "Keep your upper arms stationary throughout."
        ],
        tips: [
            "This can be done seated or standing.",
            "Don't let your elbows flare out wide.",
            "Use a weight you can control safely overhead.",
            "Focus on the tricep muscles doing the work."
        ],
        muscleGroups: ["Triceps"],
        videoUrl: exerciseVideos["TricepPress"],
        image: null
    },

    "TricepDips": {
        title: "Tricep Dips",
        description: "A bodyweight exercise targeting the triceps using parallel bars or similar equipment.",
        steps: [
            "Support yourself on parallel bars with arms extended.",
            "Lower your body by bending your elbows.",
            "Keep your torso upright for tricep emphasis.",
            "Lower until your shoulders are below your elbows.",
            "Push back up to the starting position."
        ],
        tips: [
            "Keep your legs straight for more difficulty.",
            "Don't go too low if you feel shoulder discomfort.",
            "Lean forward slightly to engage more chest.",
            "This is a challenging exercise - progress gradually."
        ],
        muscleGroups: ["Triceps", "Chest", "Shoulders"],
        videoUrl: exerciseVideos["TricepDips"],
        image: null
    },

    // ===== FOREARM EXERCISES =====
    "FarmerSquats": {
        title: "Farmer Squats",
        description: "Squats performed while holding heavy weights to challenge grip and core strength.",
        steps: [
            "Hold heavy weights (dumbbells, kettlebells) at your sides.",
            "Stand with feet shoulder-width apart.",
            "Lower into a squat position while holding the weights.",
            "Keep your chest up and core engaged.",
            "Return to the starting position."
        ],
        tips: [
            "This challenges your grip strength significantly.",
            "Use straps if grip becomes the limiting factor.",
            "Keep the weights balanced and controlled.",
            "Focus on maintaining good squat form despite the added challenge."
        ],
        muscleGroups: ["Quadriceps", "Glutes", "Forearms", "Traps", "Core"],
        videoUrl: exerciseVideos["FarmerSquats"],
        image: null
    },

    "WristCurls": {
        title: "Wrist Curls",
        description: "An isolation exercise targeting the wrist flexor muscles in the forearms.",
        steps: [
            "Sit with your forearms resting on your thighs or a bench.",
            "Hold a light weight with your palms facing up.",
            "Let your wrists hang over the edge.",
            "Curl your wrists up by flexing your forearms.",
            "Lower back down with control."
        ],
        tips: [
            "Use light weights - these muscles are small.",
            "Focus on full range of motion.",
            "Keep your forearms stable throughout.",
            "This helps prevent wrist injuries and improves grip strength."
        ],
        muscleGroups: ["Forearm Flexors"],
        videoUrl: exerciseVideos["WristCurls"],
        image: null
    },

    "ReverseWristCurls": {
        title: "Reverse Wrist Curls",
        description: "An isolation exercise targeting the wrist extensor muscles in the forearms.",
        steps: [
            "Sit with your forearms resting on your thighs or a bench.",
            "Hold a light weight with your palms facing down.",
            "Let your wrists hang over the edge.",
            "Lift your wrists up by extending your forearms.",
            "Lower back down with control."
        ],
        tips: [
            "Use even lighter weights than regular wrist curls.",
            "The extensor muscles are typically weaker than flexors.",
            "This helps balance forearm strength and prevent injury.",
            "Keep the movement slow and controlled."
        ],
        muscleGroups: ["Forearm Extensors"],
        videoUrl: exerciseVideos["ReverseWristCurls"],
        image: null
    },

    "FarmersWalks": {
        title: "Farmers Walks",
        description: "A functional exercise carrying heavy weights to build grip strength and overall conditioning.",
        steps: [
            "Pick up heavy weights (dumbbells, kettlebells, or farmer's walk handles).",
            "Stand tall with weights at your sides.",
            "Walk forward with short, quick steps.",
            "Keep your core engaged and shoulders back.",
            "Walk for a predetermined distance or time."
        ],
        tips: [
            "This is one of the best functional exercises.",
            "Keep your shoulders level - don't let one side drop.",
            "Breathe normally during the walk.",
            "Start with lighter weights and build up gradually."
        ],
        muscleGroups: ["Forearms", "Traps", "Core", "Legs"],
        videoUrl: exerciseVideos["FarmersWalks"],
        image: null
    },
    // ===== ABDOMINAL EXERCISES =====
    "AbsInAndOut": {
        title: "Abs In and Out",
        description: "A dynamic core exercise alternating between knee tucks and leg extensions.",
        steps: [
            "Sit on the floor with your hands behind you for support.",
            "Lift your feet off the ground and lean back slightly.",
            "Bring your knees toward your chest (in position).",
            "Extend your legs straight out (out position).",
            "Alternate between in and out positions."
        ],
        tips: [
            "Keep your feet off the ground throughout the exercise.",
            "Focus on using your abs to control the movement.",
            "Don't let your back round excessively.",
            "Keep the movement controlled, not bouncy."
        ],
        muscleGroups: ["Abs", "Hip Flexors"],
        videoUrl: exerciseVideos["AbsInAndOut"],
        image: null
    },

    "AbScissors": {
        title: "Ab Scissors",
        description: "A lying abdominal exercise with alternating leg movements resembling scissors.",
        steps: [
            "Lie on your back with hands by your sides or under your lower back.",
            "Lift both legs off the ground.",
            "Alternate lifting one leg up while the other goes down.",
            "Keep both legs straight throughout the movement.",
            "Continue the scissoring motion for desired reps."
        ],
        tips: [
            "Keep your lower back pressed to the floor.",
            "Don't let your legs touch the ground.",
            "Keep the movement controlled and steady.",
            "Focus on keeping your core engaged throughout."
        ],
        muscleGroups: ["Lower Abs", "Hip Flexors"],
        videoUrl: exerciseVideos["AbScissors"],
        image: null
    },

    "AbsCrunchesDumbbells": {
        title: "Abs Crunches with Dumbbells",
        description: "Traditional crunches performed while holding dumbbells for added resistance.",
        steps: [
            "Lie on your back with knees bent and feet flat on the floor.",
            "Hold a dumbbell against your chest with both hands.",
            "Lift your shoulders off the ground by contracting your abs.",
            "Hold briefly at the top.",
            "Lower back down with control."
        ],
        tips: [
            "Start with a light weight and progress gradually.",
            "Don't sit up completely - just lift your shoulders.",
            "Keep your lower back pressed to the floor.",
            "Focus on quality over quantity."
        ],
        muscleGroups: ["Upper Abs"],
        videoUrl: exerciseVideos["AbsCrunchesDumbbells"],
        image: null
    },

    "AbsCrunchesDumbbellsLegs": {
        title: "Abs Crunches with Dumbbells and Legs",
        description: "A combination crunch exercise with dumbbells and leg raises for total core engagement.",
        steps: [
            "Lie on your back holding a dumbbell against your chest.",
            "Lift your legs off the ground with knees bent at 90 degrees.",
            "Simultaneously crunch up with your torso and bring knees toward chest.",
            "Lower both your torso and legs with control.",
            "Repeat the combined movement."
        ],
        tips: [
            "This is a challenging exercise - start with lighter weights.",
            "Keep your movements coordinated and controlled.",
            "Don't let your lower back arch off the floor.",
            "Focus on the contraction in your entire core."
        ],
        muscleGroups: ["Upper Abs", "Lower Abs", "Hip Flexors"],
        videoUrl: exerciseVideos["AbsCrunchesDumbbellsLegs"],
        image: null
    },

    "BicycleCrunches": {
        title: "Bicycle Crunches",
        description: "A dynamic core exercise that targets the abs and obliques with a cycling motion.",
        steps: [
            "Lie on your back with hands behind your head.",
            "Lift your shoulders off the ground and bring knees toward chest.",
            "Bring your right elbow toward your left knee while extending the right leg.",
            "Switch sides, bringing left elbow toward right knee.",
            "Continue alternating in a cycling motion."
        ],
        tips: [
            "Don't pull on your neck with your hands.",
            "Focus on rotating your torso, not just moving your elbows.",
            "Keep your core engaged throughout.",
            "Make sure to fully extend the leg on each side."
        ],
        muscleGroups: ["Abs", "Obliques", "Hip Flexors"],
        videoUrl: exerciseVideos["BicycleCrunches"],
        image: null
    },

    "BicycleCrunchesLegsLower": {
        title: "Bicycle Crunches Legs Lower",
        description: "A variation of bicycle crunches with legs closer to the ground for increased difficulty.",
        steps: [
            "Lie on your back with hands behind your head.",
            "Lift your shoulders off the ground.",
            "Keep your legs lower to the ground (about 6 inches off).",
            "Perform the bicycle motion with your legs closer to the floor.",
            "Alternate bringing elbows to opposite knees."
        ],
        tips: [
            "This is more challenging than regular bicycle crunches.",
            "Keep your lower back pressed to the floor.",
            "The lower leg position increases core activation.",
            "Move slowly and with control."
        ],
        muscleGroups: ["Lower Abs", "Obliques", "Hip Flexors"],
        videoUrl: exerciseVideos["BicycleCrunchesLegsLower"],
        image: null
    },

    "CrunchAndPunch": {
        title: "Crunch and Punch",
        description: "A combination exercise mixing abdominal crunches with punching motions.",
        steps: [
            "Lie on your back with knees bent and feet flat.",
            "Crunch up bringing your shoulders off the ground.",
            "While in the crunch position, alternate punching forward with each arm.",
            "Lower back down and repeat the combination.",
            "Keep your core engaged throughout."
        ],
        tips: [
            "Coordinate the crunch and punching motions smoothly.",
            "Don't rush through the movements.",
            "Keep your punches controlled, not wild.",
            "This adds an upper body element to the core work."
        ],
        muscleGroups: ["Abs", "Shoulders", "Arms"],
        videoUrl: exerciseVideos["CrunchAndPunch"],
        image: null
    },

    "Crunches": {
        title: "Crunches",
        description: "A basic abdominal exercise targeting the rectus abdominis.",
        steps: [
            "Lie on your back with knees bent and feet flat on the floor.",
            "Place your hands behind your head or across your chest.",
            "Lift your shoulders off the ground by contracting your abs.",
            "Hold briefly at the top.",
            "Lower back down with control."
        ],
        tips: [
            "Don't sit up completely - just lift your shoulders.",
            "Keep your lower back pressed to the floor.",
            "Don't pull on your neck if hands are behind your head.",
            "Focus on quality over quantity."
        ],
        muscleGroups: ["Upper Abs"],
        videoUrl: exerciseVideos["Crunches"],
        image: null
    },

    "CrossLeggedSeatedRaises": {
        title: "Cross Legged Seated Raises",
        description: "A seated abdominal exercise performed in a cross-legged position.",
        steps: [
            "Sit cross-legged on the floor with hands behind you for support.",
            "Lean back slightly and lift your crossed legs off the ground.",
            "Bring your knees toward your chest.",
            "Extend your legs back out while keeping them elevated.",
            "Repeat the in and out motion."
        ],
        tips: [
            "Keep your legs crossed throughout the exercise.",
            "Focus on using your abs to control the movement.",
            "Don't let your feet touch the ground.",
            "This variation challenges stability and core strength."
        ],
        muscleGroups: ["Abs", "Hip Flexors", "Core Stability"],
        videoUrl: exerciseVideos["CrossLeggedSeatedRaises"],
        image: null
    },

    "DeadBugs": {
        title: "Dead Bugs",
        description: "A core stability exercise that challenges coordination and anti-extension strength.",
        steps: [
            "Lie on your back with arms extended toward the ceiling.",
            "Bring your knees up to 90 degrees (tabletop position).",
            "Slowly lower one arm overhead while extending the opposite leg.",
            "Return to the starting position and switch sides.",
            "Keep your lower back pressed to the floor throughout."
        ],
        tips: [
            "Move slowly and with control.",
            "Don't let your lower back arch off the floor.",
            "Keep your core engaged throughout the movement.",
            "This exercise is harder than it looks - focus on form."
        ],
        muscleGroups: ["Deep Core", "Abs", "Shoulders"],
        videoUrl: exerciseVideos["DeadBugs"],
        image: null
    },

    "FeetStackedCrunches": {
        title: "Feet Stacked Crunches",
        description: "Crunches performed with feet stacked on top of each other for added challenge.",
        steps: [
            "Lie on your back and stack one foot on top of the other.",
            "Keep your legs elevated with knees bent.",
            "Place your hands behind your head.",
            "Perform crunches while maintaining the stacked foot position.",
            "This position challenges your stability."
        ],
        tips: [
            "The stacked position makes balance more challenging.",
            "Keep your feet stacked throughout the exercise.",
            "Focus on maintaining control and stability.",
            "This variation works core stability muscles more."
        ],
        muscleGroups: ["Abs", "Core Stability"],
        videoUrl: exerciseVideos["FeetStackedCrunches"],
        image: null
    },

    "FullLegRaises": {
        title: "Full Leg Raises",
        description: "A challenging leg raise exercise targeting the lower abdominals with full range of motion.",
        steps: [
            "Lie on your back with legs straight and arms at your sides.",
            "Keep your legs together and straight.",
            "Lift your legs all the way up toward the ceiling.",
            "Lower them back down slowly without touching the floor.",
            "Maintain control throughout the full range of motion."
        ],
        tips: [
            "Keep your lower back pressed to the floor.",
            "Don't let your legs drop quickly.",
            "Stop just before your legs touch the floor.",
            "This is more challenging than regular leg raises."
        ],
        muscleGroups: ["Lower Abs", "Hip Flexors"],
        videoUrl: exerciseVideos["FullLegRaises"],
        image: null
    },

    "HangingLegRaises": {
        title: "Hanging Leg Raises",
        description: "An advanced core exercise performed while hanging from a pull-up bar.",
        steps: [
            "Hang from a pull-up bar with arms fully extended.",
            "Keep your legs straight (or knees bent for easier version).",
            "Lift your legs up toward your chest.",
            "Lower them back down with control.",
            "Don't swing or use momentum."
        ],
        tips: [
            "This requires significant grip strength.",
            "Start with knee raises if straight leg raises are too difficult.",
            "Don't swing your body during the movement.",
            "Focus on using your abs to lift your legs."
        ],
        muscleGroups: ["Lower Abs", "Hip Flexors", "Forearms"],
        videoUrl: exerciseVideos["HangingLegRaises"],
        image: null
    },

    "HipRaiseHold": {
        title: "Hip Raise Hold",
        description: "An isometric exercise holding the hip raise position for time.",
        steps: [
            "Lie on your back with knees bent and feet flat on the floor.",
            "Lift your hips off the ground into a bridge position.",
            "Hold this position for the desired amount of time.",
            "Keep your glutes and core engaged throughout.",
            "Lower back down with control."
        ],
        tips: [
            "Squeeze your glutes at the top position.",
            "Don't let your hips sag during the hold.",
            "Breathe normally while holding the position.",
            "Start with shorter holds and gradually increase time."
        ],
        muscleGroups: ["Glutes", "Hamstrings", "Core"],
        videoUrl: exerciseVideos["HipRaiseHold"],
        image: null
    },

    "HipRaises": {
        title: "Hip Raises",
        description: "A glute and hamstring exercise that also engages the core muscles.",
        steps: [
            "Lie on your back with knees bent and feet flat on the floor.",
            "Lift your hips off the ground by squeezing your glutes.",
            "Create a straight line from your knees to your shoulders.",
            "Hold briefly at the top.",
            "Lower back down with control."
        ],
        tips: [
            "Focus on squeezing your glutes, not just lifting your hips.",
            "Don't arch your back excessively.",
            "Keep your core engaged throughout.",
            "This exercise also strengthens the posterior chain."
        ],
        muscleGroups: ["Glutes", "Hamstrings", "Core"],
        videoUrl: exerciseVideos["HipRaises"],
        image: null
    },

    "HipRaisesLeft": {
        title: "Hip Raises Left",
        description: "Single-leg hip raises performed with the left leg for unilateral strength.",
        steps: [
            "Lie on your back with your left knee bent and foot flat.",
            "Extend your right leg straight out.",
            "Lift your hips off the ground using only your left leg.",
            "Hold briefly at the top.",
            "Lower back down with control."
        ],
        tips: [
            "This is significantly harder than two-leg hip raises.",
            "Keep your extended leg straight and engaged.",
            "Focus on using your left glute to lift.",
            "Don't let your hips tilt to one side."
        ],
        muscleGroups: ["Left Glute", "Hamstrings", "Core"],
        videoUrl: exerciseVideos["HipRaisesLeft"],
        image: null
    },

    "HipRaisesRight": {
        title: "Hip Raises Right",
        description: "Single-leg hip raises performed with the right leg for unilateral strength.",
        steps: [
            "Lie on your back with your right knee bent and foot flat.",
            "Extend your left leg straight out.",
            "Lift your hips off the ground using only your right leg.",
            "Hold briefly at the top.",
            "Lower back down with control."
        ],
        tips: [
            "This is significantly harder than two-leg hip raises.",
            "Keep your extended leg straight and engaged.",
            "Focus on using your right glute to lift.",
            "Don't let your hips tilt to one side."
        ],
        muscleGroups: ["Right Glute", "Hamstrings", "Core"],
        videoUrl: exerciseVideos["HipRaisesRight"],
        image: null
    },

    "HollowHold": {
        title: "Hollow Hold",
        description: "An isometric core exercise that builds foundational abdominal strength.",
        steps: [
            "Lie on your back with arms extended overhead.",
            "Press your lower back into the floor.",
            "Lift your shoulders and legs off the ground.",
            "Hold this hollow position, creating a 'banana' shape.",
            "Breathe normally while maintaining the position."
        ],
        tips: [
            "Keep your lower back pressed to the floor at all times.",
            "If too difficult, bend your knees or keep arms at your sides.",
            "This is a fundamental gymnastics position.",
            "Focus on maintaining the hollow shape throughout."
        ],
        muscleGroups: ["Abs", "Hip Flexors"],
        videoUrl: exerciseVideos["HollowHold"],
        image: null
    },

    "HollowHoldToSuperman": {
        title: "Hollow Hold to Superman",
        description: "A dynamic exercise alternating between hollow hold and superman positions.",
        steps: [
            "Start in a hollow hold position on your back.",
            "Hold for a few seconds.",
            "Roll over onto your stomach into a superman position.",
            "Lift your chest and legs off the ground.",
            "Roll back to hollow hold and repeat."
        ],
        tips: [
            "This combines front and back core strengthening.",
            "Keep the transitions smooth and controlled.",
            "Maintain proper form in both positions.",
            "This is an advanced exercise combining multiple movements."
        ],
        muscleGroups: ["Abs", "Back", "Glutes", "Full Core"],
        videoUrl: exerciseVideos["HollowHoldToSuperman"],
        image: null
    },

    "HollowRocks": {
        title: "Hollow Rocks",
        description: "A dynamic version of the hollow hold with gentle rocking motion.",
        steps: [
            "Start in the hollow hold position.",
            "Gently rock back and forth while maintaining the hollow shape.",
            "Keep your lower back in contact with the floor.",
            "Rock smoothly without bouncing.",
            "Maintain the hollow position throughout the rocking."
        ],
        tips: [
            "Master the hollow hold before attempting hollow rocks.",
            "The rocking motion should be small and controlled.",
            "Don't let your shape break during the rocking.",
            "This adds a dynamic element to the static hollow hold."
        ],
        muscleGroups: ["Abs", "Hip Flexors"],
        videoUrl: exerciseVideos["HollowRocks"],
        image: null
    },

    "HollowRocksWithDumbbells": {
        title: "Hollow Rocks with Dumbbells",
        description: "Hollow rocks performed while holding dumbbells for added resistance.",
        steps: [
            "Hold light dumbbells in your hands.",
            "Get into the hollow hold position with arms extended.",
            "Gently rock back and forth while holding the weights.",
            "Keep the hollow shape throughout the movement.",
            "Control the dumbbells during the rocking motion."
        ],
        tips: [
            "Start with very light weights.",
            "The dumbbells significantly increase the difficulty.",
            "Keep your arms straight and controlled.",
            "This is an advanced variation of hollow rocks."
        ],
        muscleGroups: ["Abs", "Hip Flexors", "Shoulders"],
        videoUrl: exerciseVideos["HollowRocksWithDumbbells"],
        image: null
    },
    // ===== MORE ABDOMINAL EXERCISES =====
    "IsolatedCrunchesLeftAndRight": {
        title: "Isolated Crunches Left and Right",
        description: "Crunches that isolate each side of the abdominals alternately.",
        steps: [
            "Lie on your back with knees bent and feet flat.",
            "Place your hands behind your head.",
            "Crunch up and twist to bring your right elbow toward your left knee.",
            "Lower down and then crunch up twisting to the other side.",
            "Continue alternating sides with each rep."
        ],
        tips: [
            "Focus on rotating your torso, not just your elbows.",
            "Keep both shoulders off the ground when twisting.",
            "Don't pull on your neck with your hands.",
            "This targets the obliques more than regular crunches."
        ],
        muscleGroups: ["Obliques", "Abs"],
        videoUrl: exerciseVideos["IsolatedCrunchesLeftAndRight"],
        image: null
    },

    "KneeKicks": {
        title: "Knee Kicks",
        description: "A dynamic core exercise involving alternating knee kicks toward the chest.",
        steps: [
            "Lie on your back with hands by your sides or behind your head.",
            "Lift your shoulders slightly off the ground.",
            "Alternate bringing each knee toward your chest in a 'kicking' motion.",
            "Keep the non-working leg extended just above the ground.",
            "Continue alternating legs at a steady pace."
        ],
        tips: [
            "Keep your core engaged throughout the movement.",
            "Don't let your extended leg touch the ground.",
            "Keep your shoulders elevated throughout.",
            "This exercise combines cardio with core strengthening."
        ],
        muscleGroups: ["Lower Abs", "Hip Flexors"],
        videoUrl: exerciseVideos["KneeKicks"],
        image: null
    },

    "KneePlanks": {
        title: "Knee Planks",
        description: "A modified plank performed on the knees for beginners or as a progression exercise.",
        steps: [
            "Start on your hands and knees.",
            "Lower down to your forearms, keeping knees on the ground.",
            "Keep your body straight from your head to your knees.",
            "Hold this position for the desired time.",
            "Keep your core engaged throughout."
        ],
        tips: [
            "This is a great progression toward full planks.",
            "Keep your hips level - don't let them sag or pike up.",
            "Focus on maintaining a straight line from head to knees.",
            "Gradually increase hold time as you get stronger."
        ],
        muscleGroups: ["Core", "Shoulders"],
        videoUrl: exerciseVideos["KneePlanks"],
        image: null
    },

    "KneesToElbows": {
        title: "Knees to Elbows",
        description: "A standing core exercise bringing knees up to meet opposite elbows.",
        steps: [
            "Stand with feet hip-width apart and hands behind your head.",
            "Lift your right knee up toward your left elbow.",
            "Crunch your torso down to meet your knee.",
            "Return to standing and repeat on the other side.",
            "Continue alternating sides."
        ],
        tips: [
            "Focus on bringing your elbow down to meet your knee.",
            "Keep your core engaged throughout the movement.",
            "This is a great standing ab exercise.",
            "Don't rush through the movement - control is key."
        ],
        muscleGroups: ["Obliques", "Hip Flexors", "Core"],
        videoUrl: exerciseVideos["KneesToElbows"],
        image: null
    },

    "Plank": {
        title: "Plank",
        description: "A fundamental core strengthening exercise that builds stability and endurance throughout your entire core.",
        steps: [
            "Start in a push-up position with your forearms on the ground.",
            "Keep your elbows directly under your shoulders.",
            "Maintain a straight line from your head to your heels.",
            "Engage your core and glutes to maintain proper form.",
            "Hold this position for the prescribed time.",
            "Breathe steadily throughout the hold."
        ],
        tips: [
            "Don't let your hips sag or pike up - maintain a straight line.",
            "Keep your core tight and engaged the entire time.",
            "Focus on breathing normally, don't hold your breath.",
            "If you're shaking, that's normal - it means your muscles are working!",
            "Start with shorter holds and gradually increase time."
        ],
        muscleGroups: ["Core", "Shoulders", "Glutes"],
        videoUrl: exerciseVideos["Plank"],
        image: null
    },

    "Plank2": {
        title: "Plank (Advanced)",
        description: "An advanced variation of the standard plank with increased difficulty and core engagement.",
        steps: [
            "Start in a push-up position with your forearms on the ground.",
            "Keep your elbows directly under your shoulders.",
            "Lift one leg slightly off the ground for added challenge.",
            "Maintain a straight line from your head to your heels.",
            "Engage your core and glutes intensely.",
            "Hold this position while maintaining perfect form."
        ],
        tips: [
            "This variation requires even more core stability.",
            "Keep your hips level - don't let them rotate.",
            "The lifted leg should be straight and engaged.",
            "Focus on quality over quantity - perfect form is key.",
            "Return to standard plank if form breaks down."
        ],
        muscleGroups: ["Core", "Shoulders", "Glutes", "Hip Stabilizers"],
        videoUrl: exerciseVideos["Plank2"],
        image: null
    },

    "LeftIsolatedCrunches": {
        title: "Left Isolated Crunches",
        description: "Crunches that specifically target the left side of the abdominals.",
        steps: [
            "Lie on your back with knees bent and feet flat.",
            "Place your left hand behind your head and right hand on your chest.",
            "Crunch up and twist to bring your left elbow toward your right knee.",
            "Focus on contracting the left side of your abs.",
            "Lower back down with control."
        ],
        tips: [
            "Really focus on isolating the left side muscles.",
            "Don't pull on your neck with your left hand.",
            "Keep your right shoulder on the ground.",
            "This helps address imbalances between sides."
        ],
        muscleGroups: ["Left Obliques", "Left Abs"],
        videoUrl: exerciseVideos["LeftIsolatedCrunches"],
        image: null
    },

    "LegRaises": {
        title: "Leg Raises",
        description: "A lying abdominal exercise targeting the lower abs by raising the legs.",
        steps: [
            "Lie on your back with legs straight and arms at your sides.",
            "Keep your legs together and straight (or slightly bent).",
            "Lift your legs up toward the ceiling.",
            "Lower them back down slowly without touching the floor.",
            "Repeat for desired repetitions."
        ],
        tips: [
            "Keep your lower back pressed to the floor.",
            "Don't let your legs drop quickly.",
            "Place hands under your lower back for support if needed.",
            "Stop just before your legs touch the floor."
        ],
        muscleGroups: ["Lower Abs", "Hip Flexors"],
        videoUrl: exerciseVideos["LegRaises"],
        image: null
    },

    "LowLegRaiseHold": {
        title: "Low Leg Raise Hold",
        description: "An isometric exercise holding the legs just above the ground.",
        steps: [
            "Lie on your back with legs straight.",
            "Lift your legs just 6 inches off the ground.",
            "Hold this position for the desired time.",
            "Keep your lower back pressed to the floor."
        ],
        tips: [
            "Keep your lower back pressed to the floor.",
            "Don't let your legs drop quickly.",
            "Place hands under your lower back for support if needed.",
            "Stop just before your legs touch the floor."
        ],
        muscleGroups: ["Lower Abs", "Hip Flexors"],
        videoUrl: exerciseVideos["LegRaises"],
        image: null
    },
    // ===== FINAL ABDOMINAL EXERCISES =====
    "SeatedLegCircles": {
        title: "Seated Leg Circles",
        description: "Circular leg movements performed in a seated position for core stability.",
        steps: [
            "Sit on the floor with hands behind you for support.",
            "Lift your feet off the ground.",
            "Move your legs in circular motions.",
            "Complete circles in one direction, then reverse.",
            "Keep your core engaged throughout."
        ],
        tips: [
            "Keep your feet off the ground throughout the exercise.",
            "Make the circles as large as your range allows.",
            "Focus on smooth, controlled movements.",
            "This challenges core stability in multiple planes."
        ],
        muscleGroups: ["Core", "Hip Flexors", "Abs"],
        videoUrl: exerciseVideos["SeatedLegCircles"],
        image: null
    },

    "SeatedLegScissors": {
        title: "Seated Leg Scissors",
        description: "Scissor leg movements performed in a seated position.",
        steps: [
            "Sit on the floor with hands behind you for support.",
            "Lift your feet off the ground.",
            "Alternate crossing one leg over the other in a scissoring motion.",
            "Keep your legs straight throughout.",
            "Maintain the scissoring pattern continuously."
        ],
        tips: [
            "Keep your core engaged to maintain stability.",
            "Don't let your feet touch the ground.",
            "Keep the movements controlled and deliberate.",
            "This targets the lower abs and hip flexors."
        ],
        muscleGroups: ["Lower Abs", "Hip Flexors", "Core"],
        videoUrl: exerciseVideos["SeatedLegScissors"],
        image: null
    },

    "SeatedTwist": {
        title: "Seated Twist",
        description: "Rotational core exercise performed in a seated position.",
        steps: [
            "Sit on the floor with knees bent and feet lifted off the ground.",
            "Lean back slightly while keeping your back straight.",
            "Hold your hands together in front of your chest.",
            "Twist your torso to the left, then to the right.",
            "Keep your feet elevated throughout."
        ],
        tips: [
            "Focus on rotating your torso, not just moving your arms.",
            "Keep your chest up and back straight.",
            "Don't let your feet touch the ground.",
            "Add weight for increased difficulty."
        ],
        muscleGroups: ["Obliques", "Core", "Hip Flexors"],
        videoUrl: exerciseVideos["SeatedTwist"],
        image: null
    },

    "SeatedTwistsLegsElevated": {
        title: "Seated Twists Legs Elevated",
        description: "Russian twists performed with legs elevated for increased difficulty.",
        steps: [
            "Sit on the floor with knees bent and feet elevated higher off the ground.",
            "Lean back slightly while keeping your back straight.",
            "Hold your hands together or hold a weight.",
            "Twist your torso from side to side.",
            "Keep your legs elevated throughout the movement."
        ],
        tips: [
            "The higher leg elevation increases the challenge.",
            "Focus on rotating through your core.",
            "Keep your balance throughout the movement.",
            "This variation requires more core stability."
        ],
        muscleGroups: ["Obliques", "Core", "Hip Flexors"],
        videoUrl: exerciseVideos["SeatedTwistsLegsElevated"],
        image: null
    },

    "ShinTouches": {
        title: "Shin Touches",
        description: "A core exercise involving reaching toward the shins while in a crunch position.",
        steps: [
            "Lie on your back with knees bent and feet flat.",
            "Crunch up and reach your hands toward your shins.",
            "Try to touch your shins with your fingertips.",
            "Lower back down with control.",
            "Focus on the crunch motion, not just reaching."
        ],
        tips: [
            "Focus on lifting your shoulders off the ground.",
            "Don't just reach with your arms - crunch your abs.",
            "Keep your feet flat on the ground.",
            "This adds a reaching component to traditional crunches."
        ],
        muscleGroups: ["Upper Abs", "Core"],
        videoUrl: exerciseVideos["ShinTouches"],
        image: null
    },

    "SideObliquesTwistLeftRight": {
        title: "Side Obliques Twist Left Right",
        description: "A side-lying oblique exercise with twisting motions.",
        steps: [
            "Lie on your side with your bottom arm extended for support.",
            "Lift your top leg and top arm.",
            "Bring your top elbow toward your top knee in a twisting motion.",
            "Return to the extended position.",
            "Complete all reps on one side before switching."
        ],
        tips: [
            "Focus on contracting the obliques on the top side.",
            "Keep your body stable and don't roll.",
            "This isolates the obliques effectively.",
            "Work both sides equally."
        ],
        muscleGroups: ["Obliques", "Core", "Hip Flexors"],
        videoUrl: exerciseVideos["SideObliquesTwistLeftRight"],
        image: null
    },

    "SidePlankLeft": {
        title: "Side Plank Left",
        description: "An isometric core exercise performed on the left side to target obliques and lateral stability.",
        steps: [
            "Lie on your left side with your forearm on the ground.",
            "Stack your feet on top of each other.",
            "Lift your hips off the ground, creating a straight line.",
            "Hold this position while keeping your core engaged.",
            "Keep your top arm on your hip or extended toward the ceiling."
        ],
        tips: [
            "Don't let your hips sag toward the ground.",
            "Keep your shoulders stacked over your elbow.",
            "Breathe normally during the hold.",
            "Progress by increasing hold time or adding movements."
        ],
        muscleGroups: ["Left Obliques", "Core", "Shoulders"],
        videoUrl: exerciseVideos["SidePlankLeft"],
        image: null
    },

    "SidePlankRaiseRight": {
        title: "Side Plank Raise Right",
        description: "A side plank on the right side with leg raises for added challenge.",
        steps: [
            "Start in a right side plank position.",
            "Once stable, lift your top (left) leg up and down.",
            "Keep your hips elevated throughout the leg raises.",
            "Control the leg movement while maintaining the plank.",
            "Keep your core engaged throughout."
        ],
        tips: [
            "Master the basic side plank before adding leg raises.",
            "Don't let your hips drop during the leg raises.",
            "Keep the leg raises controlled and deliberate.",
            "This significantly increases the challenge."
        ],
        muscleGroups: ["Right Obliques", "Core", "Hip Abductors", "Glutes"],
        videoUrl: exerciseVideos["SidePlankRaiseRight"],
        image: null
    },

    "SidePlankThrusts": {
        title: "Side Plank Thrusts",
        description: "Dynamic thrusting movements performed in a side plank position.",
        steps: [
            "Start in a side plank position.",
            "Thrust your hips up toward the ceiling.",
            "Lower back to the starting side plank position.",
            "Repeat the thrusting motion.",
            "Keep your core engaged throughout."
        ],
        tips: [
            "Focus on driving the movement from your obliques.",
            "Keep your body aligned during the thrusts.",
            "This adds a dynamic element to the side plank.",
            "Control both the lifting and lowering phases."
        ],
        muscleGroups: ["Obliques", "Core", "Glutes"],
        videoUrl: exerciseVideos["SidePlankThrusts"],
        image: null
    },

    "SitThrusts": {
        title: "Sit Thrusts",
        description: "A dynamic exercise combining sitting motions with thrusting movements.",
        steps: [
            "Start in a seated position with hands behind you.",
            "Lift your hips up into a reverse plank position.",
            "Lower back down to the seated position.",
            "Repeat the thrusting motion.",
            "Keep your core engaged throughout."
        ],
        tips: [
            "Focus on driving through your heels and core.",
            "Keep your head in a neutral position.",
            "This works the posterior chain and core together.",
            "Control both the lifting and lowering phases."
        ],
        muscleGroups: ["Core", "Glutes", "Hamstrings", "Shoulders"],
        videoUrl: exerciseVideos["SitThrusts"],
        image: null
    },

    "SphinxPushUps": {
        title: "Sphinx Push Ups",
        description: "A push-up variation performed from the sphinx/forearm position.",
        steps: [
            "Start in a sphinx position (forearm plank).",
            "Push up onto your hands one arm at a time.",
            "Lower back down to forearms one arm at a time.",
            "Alternate which arm leads the movement.",
            "Keep your core engaged throughout."
        ],
        tips: [
            "This is similar to plank to push-up transitions.",
            "Keep your hips level throughout the movement.",
            "Don't let your body rotate or sag.",
            "Focus on smooth, controlled transitions."
        ],
        muscleGroups: ["Core", "Shoulders", "Triceps", "Chest"],
        videoUrl: exerciseVideos["SphinxPushUps"],
        image: null
    },

    "SpidermanPlanks": {
        title: "Spiderman Planks",
        description: "Plank variations with knee-to-elbow movements like Spiderman climbing.",
        steps: [
            "Start in a plank position.",
            "Bring one knee toward the elbow on the same side.",
            "Return the leg to the starting position.",
            "Repeat with the other leg.",
            "Continue alternating sides while maintaining the plank."
        ],
        tips: [
            "Keep your hips level throughout the movement.",
            "Don't let your body rotate or sag.",
            "Focus on bringing knee to elbow, not elbow to knee.",
            "This adds significant core and hip flexor work."
        ],
        muscleGroups: ["Core", "Hip Flexors", "Shoulders"],
        videoUrl: exerciseVideos["SpidermanPlanks"],
        image: null
    },

    "SupermanRocks": {
        title: "Superman Rocks",
        description: "A dynamic version of the superman exercise with rocking motions.",
        steps: [
            "Lie face down with arms extended overhead.",
            "Lift your chest, arms, and legs off the ground into superman position.",
            "Gently rock back and forth while maintaining the superman shape.",
            "Keep your limbs elevated throughout the rocking.",
            "Control the rocking motion."
        ],
        tips: [
            "Master the static superman before adding rocks.",
            "Keep the rocking motion small and controlled.",
            "Don't let your limbs touch the ground during rocking.",
            "This works the entire posterior chain."
        ],
        muscleGroups: ["Lower Back", "Glutes", "Shoulders", "Hamstrings"],
        videoUrl: exerciseVideos["SupermanRocks"],
        image: null
    },

    "Vups": {
        title: "V-Ups",
        description: "A challenging abdominal exercise that targets the entire core with a V-shaped movement.",
        steps: [
            "Lie on your back with arms extended overhead.",
            "Keep your legs straight and together.",
            "Simultaneously lift your legs and torso to form a 'V' shape.",
            "Try to touch your toes with your hands at the top.",
            "Lower back down with control."
        ],
        tips: [
            "This is an advanced exercise - build up gradually.",
            "Keep your legs straight throughout the movement.",
            "Focus on using your abs to lift both ends.",
            "Don't use momentum to swing up."
        ],
        muscleGroups: ["Upper Abs", "Lower Abs", "Hip Flexors"],
        videoUrl: exerciseVideos["Vups"],
        image: null
    },

    // ===== LEG EXERCISES =====
    "AdvancedBoxJumps": {
        title: "Advanced Box Jumps",
        description: "High-intensity plyometric jumps onto elevated surfaces for power development.",
        steps: [
            "Stand in front of a high, sturdy box or platform.",
            "Bend your knees and swing your arms back.",
            "Explosively jump up onto the box, landing softly.",
            "Stand up fully on the box.",
            "Step or jump back down and repeat."
        ],
        tips: [
            "Start with lower boxes and progress gradually.",
            "Focus on landing softly with bent knees.",
            "Make sure the box is sturdy and secure.",
            "This builds explosive power in the legs."
        ],
        muscleGroups: ["Quadriceps", "Glutes", "Calves", "Core"],
        videoUrl: exerciseVideos["AdvancedBoxJumps"],
        image: null
    },

    "AlternatingLungesWithDumbbells": {
        title: "Alternating Lunges with Dumbbells",
        description: "Dynamic lunges alternating legs while holding dumbbells for added resistance.",
        steps: [
            "Hold dumbbells at your sides or at shoulder height.",
            "Step forward into a lunge with one leg.",
            "Lower until both knees are at 90-degree angles.",
            "Push back to standing and immediately lunge with the other leg.",
            "Continue alternating legs for desired repetitions."
        ],
        tips: [
            "Keep your torso upright throughout the movement.",
            "Don't let your front knee track past your toes.",
            "Take a big enough step to maintain good form.",
            "The dumbbells add stability challenges."
        ],
        muscleGroups: ["Quadriceps", "Glutes", "Hamstrings", "Core"],
        videoUrl: exerciseVideos["AlternatingLungesWithDumbbells"],
        image: null
    },

    "BoxJumps": {
        title: "Box Jumps",
        description: "Plyometric jumps onto a box or platform to develop explosive leg power.",
        steps: [
            "Stand in front of a sturdy box or platform.",
            "Bend your knees and swing your arms back.",
            "Jump up onto the box, landing with both feet.",
            "Stand up fully on the box.",
            "Step back down and repeat."
        ],
        tips: [
            "Choose an appropriate height - you should land softly.",
            "Focus on landing quietly with bent knees.",
            "Step down rather than jumping down to reduce impact.",
            "This is excellent for developing power and athleticism."
        ],
        muscleGroups: ["Quadriceps", "Glutes", "Calves"],
        videoUrl: exerciseVideos["BoxJumps"],
        image: null
    },
    // ===== MORE LEG EXERCISES =====
    "BroadSkaterJumps": {
        title: "Broad Skater Jumps",
        description: "Wide lateral jumps that mimic speed skating motions for leg power and stability.",
        steps: [
            "Start in a slight squat position.",
            "Jump laterally to one side, landing on one foot.",
            "Bring the opposite leg behind for balance (like a skater).",
            "Immediately jump to the other side.",
            "Continue alternating sides with broad, powerful jumps."
        ],
        tips: [
            "Focus on distance and control over speed.",
            "Land softly on each foot.",
            "Use your arms for balance and momentum.",
            "This builds lateral power and stability."
        ],
        muscleGroups: ["Quadriceps", "Glutes", "Calves", "Core"],
        videoUrl: exerciseVideos["BroadSkaterJumps"],
        image: null
    },

    "BurpeeWithDumbbell": {
        title: "Burpee with Dumbbell",
        description: "A full-body burpee exercise performed while holding a dumbbell.",
        steps: [
            "Hold a dumbbell with both hands at chest level.",
            "Squat down and place the dumbbell on the ground.",
            "Jump your feet back into a plank position.",
            "Jump your feet back to the squat position.",
            "Pick up the dumbbell and jump up with arms overhead."
        ],
        tips: [
            "Start with a lighter dumbbell to master the movement.",
            "Keep the dumbbell secure throughout the movement.",
            "This adds resistance to an already challenging exercise.",
            "Focus on smooth transitions between positions."
        ],
        muscleGroups: ["Full Body", "Legs", "Core", "Shoulders", "Cardio"],
        videoUrl: exerciseVideos["BurpeeWithDumbbell"],
        image: null
    },

    "DumbbellReverseLunges": {
        title: "Dumbbell Reverse Lunges",
        description: "Reverse lunges performed while holding dumbbells for added resistance.",
        steps: [
            "Hold dumbbells at your sides or at shoulder height.",
            "Step backward with one leg into a lunge position.",
            "Lower until both knees are at 90-degree angles.",
            "Push through your front heel to return to starting position.",
            "Complete all reps on one side before switching."
        ],
        tips: [
            "This variation is often easier on the knees than forward lunges.",
            "Keep most of your weight on your front leg.",
            "The dumbbells add resistance and stability challenge.",
            "Step straight back, not at an angle."
        ],
        muscleGroups: ["Quadriceps", "Glutes", "Hamstrings", "Core"],
        videoUrl: exerciseVideos["DumbbellReverseLunges"],
        image: null
    },

    "DumbbellSquats": {
        title: "Dumbbell Squats",
        description: "Squats performed while holding dumbbells for added resistance and stability challenge.",
        steps: [
            "Hold dumbbells at your sides or at shoulder height.",
            "Stand with feet shoulder-width apart.",
            "Lower into a squat by bending at hips and knees.",
            "Keep your chest up and knees tracking over toes.",
            "Drive through your heels to return to standing."
        ],
        tips: [
            "Dumbbells can be held in various positions (sides, shoulders, goblet).",
            "Keep your weight on your heels.",
            "Don't let your knees cave inward.",
            "Go only as low as you can maintain good form."
        ],
        muscleGroups: ["Quadriceps", "Glutes", "Hamstrings", "Core"],
        videoUrl: exerciseVideos["DumbbellSquats"],
        image: null
    },

    "DumbbellThruster": {
        title: "Dumbbell Thruster",
        description: "A combination squat and overhead press movement using dumbbells.",
        steps: [
            "Hold dumbbells at shoulder height.",
            "Stand with feet shoulder-width apart.",
            "Lower into a squat position.",
            "As you stand up explosively, press the dumbbells overhead.",
            "Lower the weights back to shoulders and repeat."
        ],
        tips: [
            "Use the momentum from the squat to help with the press.",
            "Keep your core tight throughout the movement.",
            "This is an excellent full-body, high-intensity exercise.",
            "Don't pause between the squat and press - make it fluid."
        ],
        muscleGroups: ["Quadriceps", "Glutes", "Shoulders", "Core"],
        videoUrl: exerciseVideos["DumbbellThruster"],
        image: null
    },

    "JumpSquats": {
        title: "Jump Squats",
        description: "Explosive squats with a jump at the top for power and conditioning.",
        steps: [
            "Stand with feet shoulder-width apart.",
            "Lower into a squat position.",
            "Explosively jump up as high as possible.",
            "Land softly and immediately lower into the next squat.",
            "Keep your core engaged throughout."
        ],
        tips: [
            "Focus on landing softly to protect your joints.",
            "Use your arms to help generate upward momentum.",
            "This exercise significantly elevates heart rate.",
            "Start with bodyweight before adding any resistance."
        ],
        muscleGroups: ["Quadriceps", "Glutes", "Calves", "Core"],
        videoUrl: exerciseVideos["JumpSquats"],
        image: null
    },

    "JumpingLunges": {
        title: "Jumping Lunges",
        description: "Dynamic lunges with explosive jumps between leg switches for cardio and power.",
        steps: [
            "Start in a lunge position with one foot forward.",
            "Jump up explosively, switching leg positions in the air.",
            "Land in a lunge with the opposite leg forward.",
            "Immediately jump again to switch back.",
            "Continue alternating for desired repetitions."
        ],
        tips: [
            "Land softly with bent knees to absorb impact.",
            "Keep your torso upright throughout.",
            "This is a high-intensity exercise - start slowly.",
            "Focus on control rather than speed initially."
        ],
        muscleGroups: ["Quadriceps", "Glutes", "Hamstrings", "Calves", "Core"],
        videoUrl: exerciseVideos["JumpingLunges"],
        image: null
    },

    "Lunges": {
        title: "Lunges",
        description: "A unilateral leg exercise that builds strength, balance, and stability.",
        steps: [
            "Stand with feet hip-width apart.",
            "Take a large step forward with one leg.",
            "Lower your body until both knees are at 90-degree angles.",
            "Push through your front heel to return to starting position.",
            "Complete all reps on one side before switching."
        ],
        tips: [
            "Keep your torso upright throughout the movement.",
            "Don't let your front knee track past your toes.",
            "Your back knee should nearly touch the ground.",
            "Focus on stepping straight forward, not at an angle."
        ],
        muscleGroups: ["Quadriceps", "Glutes", "Hamstrings", "Core"],
        videoUrl: exerciseVideos["Lunges"],
        image: null
    },

    "PistolSquats": {
        title: "Pistol Squats",
        description: "Advanced single-leg squats requiring exceptional strength, balance, and mobility.",
        steps: [
            "Stand on one leg with the other leg extended in front of you.",
            "Lower yourself down on the standing leg.",
            "Keep the extended leg straight and off the ground.",
            "Lower until your hip is below your knee.",
            "Push through your heel to return to standing."
        ],
        tips: [
            "This is an extremely advanced exercise.",
            "Work on assisted versions first (holding a suspension trainer or door frame).",
            "Requires significant ankle, hip, and hamstring mobility.",
            "Build up strength with regular single-leg squats first."
        ],
        muscleGroups: ["Quadriceps", "Glutes", "Hamstrings", "Core", "Calves"],
        videoUrl: exerciseVideos["PistolSquats"],
        image: null
    },

    "PistolSquatsBeginner": {
        title: "Pistol Squats Beginner",
        description: "A modified version of pistol squats with assistance for those building up to the full movement.",
        steps: [
            "Hold onto a suspension trainer, door frame, or similar support.",
            "Stand on one leg with the other extended in front.",
            "Use the support to help lower yourself down.",
            "Lower as far as your mobility and strength allow.",
            "Use the support to help return to standing."
        ],
        tips: [
            "Use only as much assistance as needed.",
            "Focus on building the movement pattern first.",
            "Work on single-leg strength and flexibility separately.",
            "Gradually reduce assistance as you get stronger."
        ],
        muscleGroups: ["Quadriceps", "Glutes", "Hamstrings", "Core"],
        videoUrl: exerciseVideos["PistolSquatsBeginner"],
        image: null
    },

    "PrisonerSquats": {
        title: "Prisoner Squats",
        description: "Bodyweight squats performed with hands behind the head for added challenge.",
        steps: [
            "Stand with feet shoulder-width apart.",
            "Place your hands behind your head, fingers interlaced.",
            "Lower into a squat position while keeping hands behind head.",
            "Keep your chest up and elbows back.",
            "Drive through your heels to return to standing."
        ],
        tips: [
            "The hand position makes balance more challenging.",
            "Don't pull on your neck with your hands.",
            "Keep your elbows pulled back throughout.",
            "This variation emphasizes core stability."
        ],
        muscleGroups: ["Quadriceps", "Glutes", "Hamstrings", "Core"],
        videoUrl: exerciseVideos["PrisonerSquats"],
        image: null
    },

    "ReverseLunges": {
        title: "Reverse Lunges",
        description: "Lunges performed by stepping backward, often easier on the knees than forward lunges.",
        steps: [
            "Stand with feet hip-width apart.",
            "Step backward with one leg into a lunge position.",
            "Lower until both knees are at 90-degree angles.",
            "Push through your front heel to return to starting position.",
            "Complete all reps on one side before switching."
        ],
        tips: [
            "This variation is often easier on the knees.",
            "Keep most of your weight on your front leg.",
            "Don't let your front knee track past your toes.",
            "Step straight back, not at an angle."
        ],
        muscleGroups: ["Quadriceps", "Glutes", "Hamstrings", "Core"],
        videoUrl: exerciseVideos["ReverseLunges"],
        image: null
    },

    "ShortJumps": {
        title: "Short Jumps",
        description: "Quick, short jumps for agility and calf development.",
        steps: [
            "Stand with feet hip-width apart.",
            "Perform quick, short jumps in place.",
            "Land on the balls of your feet.",
            "Keep the jumps low and rapid.",
            "Maintain a steady rhythm."
        ],
        tips: [
            "Focus on quick ground contact time.",
            "Keep your knees slightly bent on landing.",
            "This develops calf strength and agility.",
            "Start with shorter durations and build up."
        ],
        muscleGroups: ["Calves", "Quadriceps", "Core"],
        videoUrl: exerciseVideos["ShortJumps"],
        image: null
    },

    "SideToSideJumps": {
        title: "Side to Side Jumps",
        description: "Lateral jumps from side to side for agility and leg strength.",
        steps: [
            "Stand with feet together.",
            "Jump laterally to one side, landing on both feet.",
            "Immediately jump back to the other side.",
            "Continue jumping side to side.",
            "Keep your core engaged throughout."
        ],
        tips: [
            "Land softly with bent knees.",
            "Keep the jumps controlled and deliberate.",
            "This builds lateral agility and stability.",
            "Use your arms for balance and momentum."
        ],
        muscleGroups: ["Quadriceps", "Glutes", "Calves", "Core"],
        videoUrl: exerciseVideos["SideToSideJumps"],
        image: null
    },

    "SideToSideSkaterJumps": {
        title: "Side to Side Skater Jumps",
        description: "Lateral skater-style jumps that emphasize single-leg landing and stability.",
        steps: [
            "Start in a slight squat position.",
            "Jump laterally to one side, landing on one foot.",
            "Bring the opposite leg behind for balance.",
            "Jump to the other side, landing on the opposite foot.",
            "Continue alternating sides."
        ],
        tips: [
            "Focus on single-leg stability on each landing.",
            "Use your arms for balance and momentum.",
            "Land softly and control each landing before jumping again.",
            "This mimics speed skating movements."
        ],
        muscleGroups: ["Quadriceps", "Glutes", "Calves", "Core", "Balance"],
        videoUrl: exerciseVideos["SideToSideSkaterJumps"],
        image: null
    },

    "SkaterJumpsWithGroundTouch": {
        title: "Skater Jumps with Ground Touch",
        description: "Skater jumps with the addition of touching the ground for increased range of motion.",
        steps: [
            "Start in a slight squat position.",
            "Jump laterally to one side, landing on one foot.",
            "Reach down and touch the ground with the opposite hand.",
            "Jump to the other side and touch the ground with the other hand.",
            "Continue alternating sides with ground touches."
        ],
        tips: [
            "The ground touch increases the range of motion.",
            "Keep your back straight when reaching down.",
            "Focus on controlled landings before each ground touch.",
            "This adds flexibility and mobility to the movement."
        ],
        muscleGroups: ["Quadriceps", "Glutes", "Calves", "Core", "Hamstrings"],
        videoUrl: exerciseVideos["SkaterJumpsWithGroundTouch"],
        image: null
    },

    "SquatAndPressWithDumbbells": {
        title: "Squat and Press with Dumbbells",
        description: "A compound movement combining squats with overhead pressing using dumbbells.",
        steps: [
            "Hold dumbbells at shoulder height.",
            "Stand with feet shoulder-width apart.",
            "Lower into a squat position.",
            "As you stand up, press the dumbbells overhead.",
            "Lower the weights back to shoulders and repeat."
        ],
        tips: [
            "Use the momentum from the squat to help with the press.",
            "Keep your core tight throughout the movement.",
            "Don't press the weights behind your head.",
            "This is an excellent full-body exercise."
        ],
        muscleGroups: ["Quadriceps", "Glutes", "Shoulders", "Core"],
        videoUrl: exerciseVideos["SquatAndPressWithDumbbells"],
        image: null
    },

    "StepBackLunges": {
        title: "Step Back Lunges",
        description: "Lunges performed by stepping backward for knee-friendly leg training.",
        steps: [
            "Stand with feet hip-width apart.",
            "Step backward with one leg into a lunge position.",
            "Lower until both knees are at 90-degree angles.",
            "Push through your front heel to return to starting position.",
            "Alternate legs or complete all reps on one side first."
        ],
        tips: [
            "This is the same as reverse lunges - easier on knees.",
            "Keep most of your weight on your front leg.",
            "Don't let your front knee drift past your toes.",
            "Focus on controlled movements."
        ],
        muscleGroups: ["Quadriceps", "Glutes", "Hamstrings", "Core"],
        videoUrl: exerciseVideos["StepBackLunges"],
        image: null
    },

    "StepUps": {
        title: "Step Ups",
        description: "A functional exercise stepping up onto an elevated surface to build leg strength.",
        steps: [
            "Stand in front of a sturdy step, bench, or box.",
            "Step up with one foot, placing your entire foot on the surface.",
            "Drive through your heel to step up fully.",
            "Step back down with control.",
            "Complete all reps on one side before switching."
        ],
        tips: [
            "Choose an appropriate height - your knee should be at 90 degrees or less.",
            "Don't push off with your bottom foot.",
            "Focus on controlling the descent.",
            "This is excellent for building single-leg strength."
        ],
        muscleGroups: ["Quadriceps", "Glutes", "Hamstrings", "Calves"],
        videoUrl: exerciseVideos["StepUps"],
        image: null
    },

    "StiffLeggedDeadlift": {
        title: "Stiff Legged Deadlift",
        description: "A deadlift variation emphasizing the hamstrings and glutes with minimal knee bend.",
        steps: [
            "Hold a barbell or dumbbells with feet hip-width apart.",
            "Keep your legs relatively straight (slight knee bend is okay).",
            "Hinge at the hips and lower the weight toward the ground.",
            "Feel a stretch in your hamstrings.",
            "Drive your hips forward to return to standing."
        ],
        tips: [
            "This emphasizes the hamstrings more than regular deadlifts.",
            "Keep the weight close to your body.",
            "Focus on the hip hinge movement pattern.",
            "Don't round your back to reach lower."
        ],
        muscleGroups: ["Hamstrings", "Glutes", "Lower Back"],
        videoUrl: exerciseVideos["StiffLeggedDeadlift"],
        image: null
    },

    "SumoSquats": {
        title: "Sumo Squats",
        description: "Wide-stance squats that emphasize the inner thighs and glutes.",
        steps: [
            "Stand with feet wider than shoulder-width, toes pointed out.",
            "Lower into a squat by bending at the hips and knees.",
            "Keep your knees tracking over your toes.",
            "Lower until your hips are below your knees if possible.",
            "Drive through your heels to return to standing."
        ],
        tips: [
            "The wide stance targets different muscles than regular squats.",
            "Keep your torso upright throughout the movement.",
            "Point your toes out to match your knee direction.",
            "This variation is often easier for people with long legs."
        ],
        muscleGroups: ["Quadriceps", "Glutes", "Inner Thighs", "Hamstrings"],
        videoUrl: exerciseVideos["SumoSquats"],
        image: null
    },

    "SumoWalks": {
        title: "Sumo Walks",
        description: "Walking movements performed in a sumo squat position for glute activation.",
        steps: [
            "Get into a sumo squat position with feet wide and toes pointed out.",
            "Stay low in the squat position.",
            "Take small steps forward while maintaining the squat.",
            "Keep your knees tracking over your toes.",
            "Walk for desired distance or time."
        ],
        tips: [
            "Stay as low as possible throughout the walk.",
            "Keep constant tension on your glutes and quads.",
            "Take small, controlled steps.",
            "This is excellent for glute activation and endurance."
        ],
        muscleGroups: ["Glutes", "Quadriceps", "Inner Thighs", "Core"],
        videoUrl: exerciseVideos["SumoWalks"],
        image: null
    },

    "WarriorIII": {
        title: "Warrior III",
        description: "A yoga-inspired single-leg balance exercise that builds strength and stability.",
        steps: [
            "Stand on one leg with a slight bend in the knee.",
            "Hinge forward at the hips while lifting the other leg behind you.",
            "Extend your arms forward for balance.",
            "Form a straight line from your fingertips to your lifted heel.",
            "Hold the position while balancing on one leg."
        ],
        tips: [
            "This requires significant balance and core stability.",
            "Keep your hips square to the ground.",
            "Focus on a point in front of you for balance.",
            "Start with shorter holds and progress gradually."
        ],
        muscleGroups: ["Glutes", "Hamstrings", "Core", "Balance", "Ankles"],
        videoUrl: exerciseVideos["WarriorIII"],
        image: null
    },
    // ===== GYM EXERCISES =====
    "BenchPress": {
        title: "Bench Press",
        description: "A fundamental upper body pressing exercise using a barbell on a bench.",
        steps: [
            "Lie on a bench with your eyes under the barbell.",
            "Grip the bar slightly wider than shoulder-width.",
            "Unrack the bar and position it over your chest.",
            "Lower the bar to your chest with control.",
            "Press the bar back up to the starting position."
        ],
        tips: [
            "Keep your feet flat on the floor.",
            "Maintain a slight arch in your back.",
            "Lower the bar to your chest, not your neck.",
            "Always use a spotter for heavy weights."
        ],
        muscleGroups: ["Chest", "Shoulders", "Triceps"],
        videoUrl: exerciseVideos["BenchPress"],
        image: null
    },

    "Deadlifts": {
        title: "Barbell Deadlifts",
        description: "The king of compound exercises, targeting the entire posterior chain.",
        steps: [
            "Stand with feet hip-width apart, bar over mid-foot.",
            "Bend at hips and knees to grip the bar.",
            "Keep your back neutral and chest up.",
            "Drive through your heels and hips to lift the bar.",
            "Stand up fully, then lower the bar back down."
        ],
        tips: [
            "This is the most important exercise to learn properly.",
            "Keep the bar close to your body throughout the lift.",
            "Focus on pushing the floor away with your feet.",
            "Start light and focus on perfect form."
        ],
        muscleGroups: ["Hamstrings", "Glutes", "Lower Back", "Traps", "Forearms"],
        videoUrl: exerciseVideos["Deadlifts"],
        image: null
    },

    "Squats": {
        title: "Barbell Back Squats",
        description: "The king of leg exercises, performed with a barbell across the shoulders.",
        steps: [
            "Position the barbell on your upper back (high bar or low bar).",
            "Stand with feet shoulder-width apart.",
            "Lower by bending at the hips and knees simultaneously.",
            "Keep your chest up and knees tracking over toes.",
            "Drive through your heels to return to standing."
        ],
        tips: [
            "Go only as low as you can maintain good form.",
            "Keep your weight balanced across your feet.",
            "Don't let your knees cave inward.",
            "This exercise requires good mobility in ankles, hips, and thoracic spine."
        ],
        muscleGroups: ["Quadriceps", "Glutes", "Hamstrings", "Core"],
        videoUrl: exerciseVideos["Squats"],
        image: null
    },

    "MilitaryPress": {
        title: "Military Press",
        description: "A strict overhead pressing movement performed standing with a barbell.",
        steps: [
            "Stand with feet hip-width apart holding a barbell at shoulder height.",
            "Keep your core tight and glutes engaged.",
            "Press the bar straight up overhead.",
            "Lock out your arms at the top.",
            "Lower the bar back to shoulder height with control."
        ],
        tips: [
            "Don't arch your back excessively.",
            "Keep the bar path straight up and down.",
            "Engage your core throughout the movement.",
            "This is stricter than a push press - no leg drive allowed."
        ],
        muscleGroups: ["Shoulders", "Triceps", "Core"],
        videoUrl: exerciseVideos["MilitaryPress"],
        image: null
    },

    "AirSquats": {
        title: "Air Squats",
        description: "Basic bodyweight squats without any external resistance.",
        steps: [
            "Stand with feet shoulder-width apart.",
            "Lower by bending at the hips and knees.",
            "Keep your chest up and weight on your heels.",
            "Lower until your hips are below your knees.",
            "Drive through your heels to return to standing."
        ],
        tips: [
            "This is the foundation for all squat variations.",
            "Focus on perfect form before adding weight.",
            "Keep your knees tracking over your toes.",
            "Practice the movement pattern regularly."
        ],
        muscleGroups: ["Quadriceps", "Glutes", "Hamstrings", "Core"],
        videoUrl: exerciseVideos["AirSquats"],
        image: null
    },

    // ===== OVERALL/COMPOUND MOVEMENTS =====
    "BurpeePlusHillClimbers": {
        title: "Burpee Plus Hill Climbers",
        description: "A combination exercise mixing burpees with mountain climbers for maximum intensity.",
        steps: [
            "Perform a standard burpee (squat, plank, push-up, jump).",
            "After the jump, immediately drop back to plank position.",
            "Perform 4-6 mountain climber steps.",
            "Jump back up and repeat the entire sequence.",
            "Continue for desired repetitions."
        ],
        tips: [
            "This is an extremely high-intensity exercise.",
            "Focus on maintaining form despite the intensity.",
            "Start with fewer mountain climbers if needed.",
            "This combines strength, cardio, and coordination."
        ],
        muscleGroups: ["Full Body", "Cardio", "Core", "Legs", "Arms"],
        videoUrl: exerciseVideos["BurpeePlusHillClimbers"],
        image: null
    },

    "MountainClimbers": {
        title: "Mountain Climbers",
        description: "A dynamic cardio exercise that combines core strengthening with cardiovascular conditioning.",
        steps: [
            "Start in a plank position with hands directly under your shoulders.",
            "Keep your body in a straight line from head to heels.",
            "Bring your right knee toward your chest, keeping your core tight.",
            "Quickly switch legs, bringing your left knee to your chest.",
            "Continue alternating legs in a running motion.",
            "Maintain a steady, controlled pace throughout."
        ],
        tips: [
            "Keep your hips level - don't let them bounce up and down.",
            "Maintain the plank position throughout the movement.",
            "Focus on bringing your knees toward your chest, not just lifting them.",
            "Keep your core engaged to protect your lower back.",
            "Start slower and build up speed as you get more comfortable.",
            "Breathe steadily - don't hold your breath."
        ],
        muscleGroups: ["Core", "Cardio", "Shoulders", "Hip Flexors"],
        videoUrl: exerciseVideos["MountainClimbers"],
        image: null
    },

    "MountainClimbers2": {
        title: "Mountain Climbers2",
        description: "A dynamic cardio exercise that combines core strengthening with cardiovascular conditioning.",
        steps: [
            "Start in a plank position with hands directly under your shoulders.",
            "Keep your body in a straight line from head to heels.",
            "Bring your right knee toward your chest, keeping your core tight.",
            "Quickly switch legs, bringing your left knee to your chest.",
            "Continue alternating legs in a running motion.",
            "Maintain a steady, controlled pace throughout."
        ],
        tips: [
            "Keep your hips level - don't let them bounce up and down.",
            "Maintain the plank position throughout the movement.",
            "Focus on bringing your knees toward your chest, not just lifting them.",
            "Keep your core engaged to protect your lower back.",
            "Start slower and build up speed as you get more comfortable.",
            "Breathe steadily - don't hold your breath."
        ],
        muscleGroups: ["Core", "Cardio", "Shoulders", "Hip Flexors"],
        videoUrl: exerciseVideos["MountainClimbers2"],
        image: null
    },

    "BurpeePlusPushUpAndPress": {
        title: "Burpee Plus Push Up and Press",
        description: "An advanced burpee variation with additional push-up and overhead press.",
        steps: [
            "Squat down and place your hands on the ground.",
            "Jump your feet back into plank position.",
            "Perform a push-up.",
            "Jump your feet back to squat position.",
            "Jump up with arms overhead in a pressing motion."
        ],
        tips: [
            "This adds upper body work to the standard burpee.",
            "Focus on quality push-ups even when fatigued.",
            "The overhead press adds shoulder engagement.",
            "This is a complete full-body exercise."
        ],
        muscleGroups: ["Full Body", "Chest", "Shoulders", "Core", "Legs"],
        videoUrl: exerciseVideos["BurpeePlusPushUpAndPress"],
        image: null
    },

    "OneArmBurpees": {
        title: "One Arm Burpees",
        description: "An extremely challenging burpee variation performed with only one arm.",
        steps: [
            "Squat down and place one hand on the ground.",
            "Jump your feet back into a single-arm plank.",
            "Perform a one-arm push-up (or hold the plank).",
            "Jump your feet back to squat position.",
            "Jump up with your free arm overhead."
        ],
        tips: [
            "This is an extremely advanced exercise.",
            "Start by just holding the one-arm plank if push-ups are too difficult.",
            "Alternate arms between sets or reps.",
            "Requires exceptional core and upper body strength."
        ],
        muscleGroups: ["Full Body", "Core", "Shoulders", "Chest", "Stability"],
        videoUrl: exerciseVideos["OneArmBurpees"],
        image: null
    },

    "Sprawls": {
        title: "Sprawls",
        description: "A dynamic full-body exercise similar to burpees but with a focus on the sprawling motion.",
        steps: [
            "Start in a standing position.",
            "Drop down and sprawl your legs back into a plank position.",
            "Quickly bring your feet back under you.",
            "Return to standing position.",
            "Repeat the sprawling motion rapidly."
        ],
        tips: [
            "This is faster-paced than traditional burpees.",
            "Focus on quick transitions between positions.",
            "Keep your core engaged throughout.",
            "This is excellent for conditioning and agility."
        ],
        muscleGroups: ["Full Body", "Core", "Cardio", "Agility"],
        videoUrl: exerciseVideos["Sprawls"],
        image: null
    },

    // ===== ADDITIONAL SPECIFIC EXERCISES =====
    "RussianDumbbellSwing": {
        title: "Russian Dumbbell Swing",
        description: "A hip-hinge movement using a dumbbell for posterior chain and core development.",
        steps: [
            "Hold a dumbbell with both hands at arm's length.",
            "Stand with feet shoulder-width apart.",
            "Hinge at the hips and swing the dumbbell between your legs.",
            "Drive your hips forward to swing the dumbbell to chest height.",
            "Let the dumbbell swing back down and repeat."
        ],
        tips: [
            "The power comes from your hips, not your arms.",
            "Keep your back straight throughout the movement.",
            "Don't swing higher than chest level (Russian style).",
            "This is excellent for building explosive hip power."
        ],
        muscleGroups: ["Glutes", "Hamstrings", "Core", "Shoulders"],
        videoUrl: exerciseVideos["RussianDumbbellSwing"],
        image: null
    },

    // ===== CALF EXERCISES =====
    "CalfRaises": {
        title: "Calf Raises",
        description: "A simple exercise for building calf muscle strength and size.",
        steps: [
            "Stand with feet hip-width apart.",
            "Raise up onto your toes by contracting your calf muscles.",
            "Hold briefly at the top.",
            "Lower back down with control.",
            "Repeat for desired repetitions."
        ],
        tips: [
            "Focus on the full range of motion.",
            "Don't bounce at the bottom - control the movement.",
            "Can be done with body weight or added resistance.",
            "Try single-leg variations for increased difficulty."
        ],
        muscleGroups: ["Calves"],
        videoUrl: exerciseVideos["CalfRaises"],
        image: null
    },

    // ===== OBLIQUE EXERCISES =====
    "RussianTwists": {
        title: "Russian Twists",
        description: "A rotational core exercise targeting the obliques and deep abdominal muscles.",
        steps: [
            "Sit on the floor with knees bent and feet lifted off the ground.",
            "Lean back slightly while keeping your back straight.",
            "Hold your hands together or hold a weight.",
            "Rotate your torso to one side, then the other.",
            "Keep your feet elevated throughout the movement."
        ],
        tips: [
            "Focus on rotating your torso, not just moving your arms.",
            "Keep your chest up and back straight.",
            "Adding weight increases the difficulty.",
            "Don't rush the movement - control is key."
        ],
        muscleGroups: ["Obliques", "Core", "Hip Flexors"],
        videoUrl: exerciseVideos["RussianTwists"],
        image: null
    },

    "SidePlank": {
        title: "Side Plank",
        description: "An isometric exercise targeting the obliques and lateral core stability.",
        steps: [
            "Lie on your side with your forearm on the ground.",
            "Stack your feet on top of each other.",
            "Lift your hips off the ground, creating a straight line.",
            "Hold this position while keeping your core engaged.",
            "Keep your top arm on your hip or extended toward the ceiling."
        ],
        tips: [
            "Don't let your hips sag toward the ground.",
            "Keep your shoulders stacked over your elbow.",
            "Breathe normally during the hold.",
            "Progress by increasing hold time or adding movements."
        ],
        muscleGroups: ["Obliques", "Core", "Shoulders"],
        videoUrl: exerciseVideos["SidePlank"],
        image: null
    },


    "LegExtensions": {
        title: "Leg Extensions",
        description: "An isolation exercise for the quadriceps using a leg extension machine.",
        steps: [
            "Sit in the leg extension machine with your back against the pad.",
            "Position your legs under the padded lever.",
            "Extend your legs until they're straight.",
            "Hold briefly at the top.",
            "Lower the weight back down with control."
        ],
        tips: [
            "This isolates the quadriceps muscles.",
            "Don't swing or use momentum.",
            "Focus on the squeeze at the top.",
            "Control the negative portion of the movement."
        ],
        muscleGroups: ["Quadriceps"],
        videoUrl: exerciseVideos["LegExtensions"],
        image: null
    },

    "LegCurls": {
        title: "Leg Curls",
        description: "An isolation exercise for the hamstrings using a leg curl machine.",
        steps: [
            "Lie face down on the leg curl machine.",
            "Position your legs under the padded lever.",
            "Curl your heels toward your glutes.",
            "Squeeze your hamstrings at the top.",
            "Lower the weight back down with control."
        ],
        tips: [
            "This isolates the hamstring muscles.",
            "Keep your hips pressed to the pad.",
            "Don't lift your hips during the movement.",
            "Focus on the contraction in your hamstrings."
        ],
        muscleGroups: ["Hamstrings"],
        videoUrl: exerciseVideos["LegCurls"],
        image: null
    },

    // ===== GLUTE EXERCISES =====
    "HipThrusts": {
        title: "Hip Thrusts",
        description: "A glute-focused exercise performed with upper back on a bench.",
        steps: [
            "Sit with your upper back against a bench.",
            "Place a barbell or weight across your hips.",
            "Plant your feet firmly on the ground.",
            "Drive through your heels to lift your hips up.",
            "Squeeze your glutes at the top and lower with control."
        ],
        tips: [
            "This is one of the best glute-building exercises.",
            "Keep your chin tucked and core engaged.",
            "Focus on driving through your heels.",
            "Squeeze your glutes hard at the top position."
        ],
        muscleGroups: ["Glutes", "Hamstrings", "Core"],
        videoUrl: exerciseVideos["HipThrusts"],
        image: null
    },

    "HipThrust": {
        title: "Hip Thrust (Single)",
        description: "A single repetition hip thrust focusing on perfect glute activation.",
        steps: [
            "Position your upper back against a bench.",
            "Place weight across your hips if using resistance.",
            "Plant your feet firmly on the ground.",
            "Drive through your heels with maximum glute contraction.",
            "Hold the top position and feel the glute engagement."
        ],
        tips: [
            "Quality over quantity - focus on perfect glute activation.",
            "Feel the muscles working throughout the movement.",
            "This builds the foundation for all hip thrust variations.",
            "Master bodyweight before adding external load."
        ],
        muscleGroups: ["Glutes", "Hamstrings", "Core"],
        videoUrl: exerciseVideos["HipThrust"],
        image: null
    },

    "GluteBridges": {
        title: "Glute Bridges",
        description: "A floor-based exercise targeting the glutes and posterior chain.",
        steps: [
            "Lie on your back with knees bent and feet flat.",
            "Place your arms at your sides for stability.",
            "Drive through your heels to lift your hips up.",
            "Squeeze your glutes at the top.",
            "Lower back down with control."
        ],
        tips: [
            "This is a great introduction to hip thrust movements.",
            "Focus on squeezing your glutes, not just lifting your hips.",
            "Keep your core engaged throughout.",
            "Don't arch your back excessively."
        ],
        muscleGroups: ["Glutes", "Hamstrings", "Core"],
        videoUrl: exerciseVideos["GluteBridges"],
        image: null
    },

    // ===== CALF EXERCISES =====
    "DonkeyCalfRaises": {
        title: "Donkey Calf Raises",
        description: "A calf exercise performed in a bent-over position for maximum stretch.",
        steps: [
            "Bend over at the waist with hands supported on a bench.",
            "Have a partner sit on your lower back (or use a donkey calf machine).",
            "Rise up onto your toes by contracting your calves.",
            "Hold briefly at the top.",
            "Lower back down for a full stretch."
        ],
        tips: [
            "This position allows for maximum calf stretch.",
            "The bent-over position increases the range of motion.",
            "Focus on full range of motion.",
            "This was a favorite exercise of Arnold Schwarzenegger."
        ],
        muscleGroups: ["Calves"],
        videoUrl: exerciseVideos["DonkeyCalfRaises"],
        image: null
    },

    "CalfPressOnLegPressMachine": {
        title: "Calf Press on Leg Press Machine",
        description: "Calf raises performed on a leg press machine for added resistance.",
        steps: [
            "Sit in the leg press machine with legs extended.",
            "Place only the balls of your feet on the bottom of the footplate.",
            "Let your heels drop for a full stretch.",
            "Press up onto your toes by contracting your calves.",
            "Hold briefly at the top and lower with control."
        ],
        tips: [
            "This allows for heavy resistance training of the calves.",
            "Focus on full range of motion.",
            "Keep your legs relatively straight throughout.",
            "The stretch at the bottom is crucial for calf development."
        ],
        muscleGroups: ["Calves"],
        videoUrl: exerciseVideos["CalfPressOnLegPressMachine"],
        image: null
    },

    // ===== TRAP EXERCISES =====
    "UprightRows": {
        title: "Upright Rows",
        description: "A pulling exercise targeting the traps and shoulders with vertical pulling motion.",
        steps: [
            "Hold a barbell or dumbbells with hands close together.",
            "Stand with feet hip-width apart.",
            "Pull the weight straight up along your body.",
            "Lead with your elbows, bringing them higher than your hands.",
            "Lower back down with control."
        ],
        tips: [
            "Don't pull too high if you feel shoulder discomfort.",
            "Keep the weight close to your body.",
            "Lead with your elbows, not your hands.",
            "This exercise targets the upper traps and front delts."
        ],
        muscleGroups: ["Traps", "Shoulders", "Biceps"],
        videoUrl: exerciseVideos["UprightRows"],
        image: null
    },

    "DumbbellFarmersWalk": {
        title: "Dumbbell Farmers Walk",
        description: "A loaded carry exercise using dumbbells for grip and trap development.",
        steps: [
            "Pick up heavy dumbbells in each hand.",
            "Stand tall with weights at your sides.",
            "Walk forward with controlled steps.",
            "Keep your shoulders level and core engaged.",
            "Walk for predetermined distance or time."
        ],
        tips: [
            "This builds functional strength and endurance.",
            "Keep your shoulders back and down.",
            "Don't let one side drop lower than the other.",
            "This is excellent for grip strength and trap development."
        ],
        muscleGroups: ["Traps", "Forearms", "Core", "Legs"],
        videoUrl: exerciseVideos["DumbbellFarmersWalk"],
        image: null
    },

    // ===== HIP EXERCISES =====
    "HipAbductionMachine": {
        title: "Hip Abduction Machine",
        description: "A machine exercise targeting the hip abductor muscles.",
        steps: [
            "Sit in the hip abduction machine with back against the pad.",
            "Position your legs against the pads.",
            "Push your legs apart against the resistance.",
            "Hold briefly at the widest position.",
            "Control the return to the starting position."
        ],
        tips: [
            "This targets the gluteus medius and other hip abductors.",
            "Don't use momentum - control the movement.",
            "Focus on the muscles on the outside of your hips.",
            "This helps improve hip stability and strength."
        ],
        muscleGroups: ["Hip Abductors", "Glutes"],
        videoUrl: exerciseVideos["HipAbductionMachine"],
        image: null
    },

    "HipAdductionMachine": {
        title: "Hip Adduction Machine",
        description: "A machine exercise targeting the hip adductor muscles.",
        steps: [
            "Sit in the hip adduction machine with back against the pad.",
            "Position your legs against the pads.",
            "Squeeze your legs together against the resistance.",
            "Hold briefly at the closest position.",
            "Control the return to the starting position."
        ],
        tips: [
            "This targets the inner thigh muscles.",
            "Focus on squeezing your legs together.",
            "Don't use momentum - control the movement.",
            "This helps improve hip stability and inner thigh strength."
        ],
        muscleGroups: ["Hip Adductors", "Inner Thighs"],
        videoUrl: exerciseVideos["HipAdductionMachine"],
        image: null
    },

    "ClamshellExercise": {
        title: "Clamshell Exercise",
        description: "A side-lying exercise for hip abductor and glute activation.",
        steps: [
            "Lie on your side with knees bent at 90 degrees.",
            "Keep your feet together throughout the movement.",
            "Rotate your top knee up while keeping feet together.",
            "Open your legs like a clamshell.",
            "Lower back down with control."
        ],
        tips: [
            "This is excellent for glute activation and hip stability.",
            "Keep your hips stacked throughout the movement.",
            "Don't let your top hip roll backward.",
            "Focus on the glute muscles doing the work."
        ],
        muscleGroups: ["Glutes", "Hip Abductors"],
        videoUrl: exerciseVideos["ClamshellExercise"],
        image: null
    },

    // ===== CHEST GYM EXERCISES =====
    "DumbbellFlyes": {
        title: "Dumbbell Flyes",
        description: "A chest isolation exercise performed lying on a bench with dumbbells.",
        steps: [
            "Lie on a bench holding dumbbells above your chest.",
            "Lower the weights out to your sides with a slight bend in your elbows.",
            "Feel a stretch in your chest muscles.",
            "Bring the weights back together above your chest.",
            "Imagine hugging a large tree trunk."
        ],
        tips: [
            "Keep a slight bend in your elbows throughout.",
            "Focus on the stretch and contraction in your chest.",
            "Don't lower the weights too far if you feel shoulder discomfort.",
            "This isolates the pectorals more than pressing movements."
        ],
        muscleGroups: ["Chest", "Shoulders"],
        videoUrl: exerciseVideos["DumbbellFlyes"],
        image: null
    },

    "CableCrossovers": {
        title: "Cable Crossovers",
        description: "A chest exercise using cables to create constant tension throughout the movement.",
        steps: [
            "Stand between two cable machines with handles at chest height.",
            "Hold a handle in each hand with arms extended.",
            "Bring your hands together in front of your chest.",
            "Squeeze your chest muscles at the peak contraction.",
            "Return to the starting position with control."
        ],
        tips: [
            "The cables provide constant tension throughout the range.",
            "Focus on squeezing your chest muscles together.",
            "Keep a slight bend in your elbows.",
            "Experiment with different angles for varied muscle activation."
        ],
        muscleGroups: ["Chest", "Shoulders"],
        videoUrl: exerciseVideos["CableCrossovers"],
        image: null
    },

    "ChestPressMachine": {
        title: "Chest Press Machine",
        description: "A machine-based chest exercise providing stability and safety.",
        steps: [
            "Sit in the chest press machine with back against the pad.",
            "Grip the handles at chest level.",
            "Press the handles forward until your arms are extended.",
            "Hold briefly at the extended position.",
            "Return to the starting position with control."
        ],
        tips: [
            "Machines provide stability and are great for beginners.",
            "Keep your back pressed against the pad.",
            "Don't lock your elbows completely at the extension.",
            "Focus on controlled movements in both directions."
        ],
        muscleGroups: ["Chest", "Shoulders", "Triceps"],
        videoUrl: exerciseVideos["ChestPressMachine"],
        image: null
    },

    "PushupsWeighted": {
        title: "Weighted Push Ups",
        description: "Push-ups performed with additional weight for increased resistance.",
        steps: [
            "Get into push-up position with a weight plate on your back.",
            "Have a partner place the weight or use a weighted vest.",
            "Perform push-ups with the added resistance.",
            "Maintain perfect form despite the extra weight.",
            "Focus on controlled movements."
        ],
        tips: [
            "Start with lighter weights and progress gradually.",
            "Make sure the weight is secure and balanced.",
            "Maintain perfect push-up form.",
            "This significantly increases the difficulty of push-ups."
        ],
        muscleGroups: ["Chest", "Shoulders", "Triceps", "Core"],
        videoUrl: exerciseVideos["PushupsWeighted"],
        image: null
    },

    "PecDeckMachine": {
        title: "Pec Deck Machine",
        description: "A machine exercise that isolates the chest muscles with a fly motion.",
        steps: [
            "Sit in the pec deck machine with back against the pad.",
            "Place your forearms against the vertical pads.",
            "Bring your arms together in front of your chest.",
            "Squeeze your chest muscles at the peak contraction.",
            "Return to the starting position with control."
        ],
        tips: [
            "This provides excellent chest isolation.",
            "Keep your back pressed against the pad.",
            "Focus on the squeeze at the peak contraction.",
            "Don't let the weight stack touch between reps."
        ],
        muscleGroups: ["Chest"],
        videoUrl: exerciseVideos["PecDeckMachine"],
        image: null
    },

    // ===== SHOULDER GYM EXERCISES =====
    "ArnoldPress": {
        title: "Arnold Press",
        description: "A shoulder press variation that incorporates rotation, named after Arnold Schwarzenegger.",
        steps: [
            "Hold dumbbells at shoulder height with palms facing your body.",
            "As you press up, rotate your palms to face forward.",
            "Press the weights overhead.",
            "Reverse the motion on the way down.",
            "End with palms facing your body again."
        ],
        tips: [
            "This targets all three heads of the deltoids.",
            "The rotation adds complexity and muscle activation.",
            "Start with lighter weights to master the movement.",
            "Keep your core engaged throughout."
        ],
        muscleGroups: ["Shoulders", "Triceps"],
        videoUrl: exerciseVideos["ArnoldPress"],
        image: null
    },

    "LateralRaises": {
        title: "Lateral Raises",
        description: "A shoulder isolation exercise targeting the middle deltoids.",
        steps: [
            "Hold dumbbells at your sides with arms straight.",
            "Raise the weights out to your sides until parallel to the floor.",
            "Keep a slight bend in your elbows.",
            "Lower back down with control.",
            "Focus on lifting with your shoulders, not your arms."
        ],
        tips: [
            "This specifically targets the middle deltoid.",
            "Don't swing or use momentum.",
            "Stop at shoulder height - don't go higher.",
            "Keep your shoulders down and back."
        ],
        muscleGroups: ["Middle Delts"],
        videoUrl: exerciseVideos["LateralRaises"],
        image: null
    },

    "FrontRaises": {
        title: "Front Raises",
        description: "A shoulder isolation exercise targeting the front deltoids.",
        steps: [
            "Hold dumbbells in front of your thighs with arms straight.",
            "Raise one or both weights straight out in front to shoulder height.",
            "Keep a slight bend in your elbows.",
            "Lower back down with control.",
            "Focus on the front deltoid muscles."
        ],
        tips: [
            "This specifically targets the front deltoid.",
            "Don't swing or use momentum.",
            "Stop at shoulder height.",
            "Can be performed alternating arms or both together."
        ],
        muscleGroups: ["Front Delts"],
        videoUrl: exerciseVideos["FrontRaises"],
        image: null
    },

    "RearDeltFlyes": {
        title: "Rear Delt Flyes",
        description: "A posterior deltoid exercise performed bent over with dumbbells.",
        steps: [
            "Bend over at the waist holding dumbbells.",
            "Let the weights hang straight down from your shoulders.",
            "Raise the weights out to your sides.",
            "Squeeze your shoulder blades together.",
            "Lower back down with control."
        ],
        tips: [
            "This targets the often-neglected rear deltoids.",
            "Keep a slight bend in your elbows.",
            "Focus on squeezing your shoulder blades together.",
            "Don't use too much weight - this is an isolation exercise."
        ],
        muscleGroups: ["Rear Delts", "Rhomboids"],
        videoUrl: exerciseVideos["RearDeltFlyes"],
        image: null
    },

    "RearDeltFlys": {
        title: "Rear Delt Flys (Alternative)",
        description: "An alternative rear deltoid exercise with slightly different form focus.",
        steps: [
            "Bend over with dumbbells hanging from your shoulders.",
            "Keep your back straight and core engaged.",
            "Fly the weights out to your sides with control.",
            "Focus on the rear deltoid contraction.",
            "Lower with resistance to the starting position."
        ],
        tips: [
            "This variation emphasizes strict form and control.",
            "Keep your movements smooth and deliberate.",
            "Focus on the mind-muscle connection.",
            "This helps balance out front-heavy shoulder development."
        ],
        muscleGroups: ["Rear Delts", "Rhomboids"],
        videoUrl: exerciseVideos["RearDeltFlys"],
        image: null
    },

    "Shrugs": {
        title: "Shrugs",
        description: "A trap exercise involving shoulder elevation with weights.",
        steps: [
            "Hold dumbbells or a barbell at your sides or in front.",
            "Keep your arms straight throughout the movement.",
            "Shrug your shoulders straight up toward your ears.",
            "Hold briefly at the top.",
            "Lower your shoulders back down with control."
        ],
        tips: [
            "Don't roll your shoulders - move straight up and down.",
            "Focus on the trap muscles doing the work.",
            "Keep your arms straight throughout.",
            "This is one of the best trap-building exercises."
        ],
        muscleGroups: ["Traps"],
        videoUrl: exerciseVideos["Shrugs"],
        image: null
    },

    "ShoulderPress": {
        title: "Shoulder Press",
        description: "A fundamental shoulder exercise pressing weights overhead.",
        steps: [
            "Hold dumbbells or a barbell at shoulder height.",
            "Press the weight straight up overhead.",
            "Extend your arms fully at the top.",
            "Lower back to shoulder height with control.",
            "Keep your core engaged throughout."
        ],
        tips: [
            "This is the foundation of all overhead pressing.",
            "Don't arch your back excessively.",
            "Press the weight in a straight line.",
            "Can be performed seated or standing."
        ],
        muscleGroups: ["Shoulders", "Triceps", "Core"],
        videoUrl: exerciseVideos["ShoulderPress"],
        image: null
    },

    // ===== ABDOMINAL GYM EXERCISES =====
    "CableCrunches": {
        title: "Cable Crunches",
        description: "Abdominal crunches performed using a cable machine for resistance.",
        steps: [
            "Kneel in front of a cable machine with a rope attachment.",
            "Hold the rope beside your head.",
            "Crunch down by contracting your abs.",
            "Focus on bringing your elbows toward your knees.",
            "Return to the starting position with control."
        ],
        tips: [
            "The cable provides constant resistance throughout the movement.",
            "Focus on crunching with your abs, not pulling with your arms.",
            "Keep your hips stationary.",
            "This allows for progressive overload of the abs."
        ],
        muscleGroups: ["Abs"],
        videoUrl: exerciseVideos["CableCrunches"],
        image: null
    },

    "AbRollouts": {
        title: "Ab Rollouts",
        description: "An advanced core exercise using an ab wheel for maximum abdominal challenge.",
        steps: [
            "Kneel on the floor holding an ab wheel.",
            "Roll the wheel forward while keeping your core tight.",
            "Extend as far as you can while maintaining control.",
            "Pull yourself back to the starting position.",
            "Keep your core engaged throughout the entire movement."
        ],
        tips: [
            "This is one of the most challenging ab exercises.",
            "Start with short ranges of motion and progress gradually.",
            "Don't let your lower back sag.",
            "Focus on pulling back with your abs, not your arms."
        ],
        muscleGroups: ["Abs", "Core", "Shoulders"],
        videoUrl: exerciseVideos["AbRollouts"],
        image: null
    },

    // ===== ADDITIONAL EXERCISES =====
    "Crunches2": {
        title: "Crunches (Variation 2)",
        description: "An alternative crunch technique with different form emphasis.",
        steps: [
            "Lie on your back with knees bent and feet flat.",
            "Place your hands across your chest or behind your head.",
            "Crunch up with deliberate, slow movement.",
            "Focus on peak contraction at the top.",
            "Lower down slowly, fighting gravity."
        ],
        tips: [
            "This variation emphasizes slow, controlled movement.",
            "Focus on quality over quantity.",
            "Feel each rep working your abdominal muscles.",
            "The slow tempo increases time under tension."
        ],
        muscleGroups: ["Upper Abs"],
        videoUrl: exerciseVideos["Crunches2"],
        image: null
    },

    "WallSit": {
        title: "Wall Sit",
        description: "An isometric leg exercise performed against a wall.",
        steps: [
            "Stand with your back against a wall.",
            "Slide down until your thighs are parallel to the floor.",
            "Keep your knees at 90 degrees.",
            "Hold this position for the desired time.",
            "Keep your back pressed against the wall."
        ],
        tips: [
            "This builds isometric strength and endurance.",
            "Don't let your knees drift inward.",
            "Keep your weight evenly distributed on both legs.",
            "Start with shorter holds and progress gradually."
        ],
        muscleGroups: ["Quadriceps", "Glutes"],
        videoUrl: exerciseVideos["WallSit"],
        image: null
    },

    "BicycleCrunch": {
        title: "Bicycle Crunch (Single)",
        description: "A single repetition bicycle crunch focusing on perfect form.",
        steps: [
            "Lie on your back with hands behind your head.",
            "Bring one knee toward your chest while extending the other leg.",
            "Rotate your torso to bring the opposite elbow toward the bent knee.",
            "Feel the contraction in your abs and obliques.",
            "Switch sides and repeat the movement."
        ],
        tips: [
            "Quality over quantity - focus on perfect form.",
            "Don't pull on your neck with your hands.",
            "Focus on the rotation of your torso.",
            "This is the foundation for all bicycle crunch variations."
        ],
        muscleGroups: ["Abs", "Obliques"],
        videoUrl: exerciseVideos["BicycleCrunch"],
        image: null
    },

    "IsoSquats": {
        title: "Iso Squats",
        description: "Isometric squats held in the bottom position for time.",
        steps: [
            "Lower into a squat position.",
            "Hold the bottom position with thighs parallel to the floor.",
            "Keep your chest up and weight on your heels.",
            "Hold for the desired time.",
            "Focus on maintaining perfect squat form."
        ],
        tips: [
            "This builds strength in the most challenging part of the squat.",
            "Keep your knees tracking over your toes.",
            "Don't let your form break during the hold.",
            "Start with shorter holds and progress gradually."
        ],
        muscleGroups: ["Quadriceps", "Glutes", "Core"],
        videoUrl: exerciseVideos["IsoSquats"],
        image: null
    },

    "RunnerslLunge": {
        title: "Runners Lunge",
        description: "A deep lunge position commonly used in running and yoga for hip flexor stretching.",
        steps: [
            "Step one foot forward into a deep lunge position.",
            "Lower your back knee toward the ground.",
            "Keep your front shin vertical.",
            "Hold the position to stretch your hip flexors.",
            "Switch legs and repeat on the other side."
        ],
        tips: [
            "This is excellent for hip flexor flexibility.",
            "Keep your front knee tracking over your toes.",
            "Feel the stretch in the hip flexor of your back leg.",
            "This is commonly used as a warm-up for runners."
        ],
        muscleGroups: ["Hip Flexors", "Quadriceps", "Glutes"],
        videoUrl: exerciseVideos["RunnerslLunge"],
        image: null
    },

    // ===== STRETCHING AND MOBILITY =====
    "ScorpionStretch": {
        title: "Scorpion Stretch",
        description: "A dynamic stretch that improves spine mobility and hip flexibility.",
        steps: [
            "Lie face down with arms extended out to your sides.",
            "Lift one leg and reach it over toward the opposite hand.",
            "Keep your chest and arms on the ground.",
            "Feel the stretch through your spine and hip.",
            "Return to starting position and repeat on the other side."
        ],
        tips: [
            "This is an advanced stretch - move slowly.",
            "Don't force the movement if you feel pain.",
            "Focus on spinal rotation and hip mobility.",
            "Great for warming up before workouts."
        ],
        muscleGroups: ["Spine", "Hips", "Glutes"],
        videoUrl: exerciseVideos["ScorpionStretch"],
        image: null
    },

    "SamsonStretch": {
        title: "Samson Stretch",
        description: "A deep lunge stretch with overhead reach for hip flexors and shoulders.",
        steps: [
            "Step into a deep lunge position.",
            "Reach both arms overhead.",
            "Lean back slightly to increase the hip flexor stretch.",
            "Hold the position and breathe deeply.",
            "Switch legs and repeat on the other side."
        ],
        tips: [
            "This combines hip flexor and shoulder stretching.",
            "Keep your front knee over your ankle.",
            "The overhead reach adds a shoulder component.",
            "Great for athletes and people who sit a lot."
        ],
        muscleGroups: ["Hip Flexors", "Shoulders", "Core"],
        videoUrl: exerciseVideos["SamsonStretch"],
        image: null
    },

    "FigureFourStretch": {
        title: "Figure Four Stretch",
        description: "A seated or lying stretch that targets the piriformis and glutes.",
        steps: [
            "Lie on your back or sit in a chair.",
            "Place one ankle on the opposite knee.",
            "Pull the bottom leg toward your chest.",
            "Feel the stretch in your glute and hip.",
            "Hold and then switch sides."
        ],
        tips: [
            "This is excellent for piriformis tightness.",
            "Gently pull the leg toward you - don't force it.",
            "You should feel the stretch in your glute.",
            "This can help with sciatic pain relief."
        ],
        muscleGroups: ["Glutes", "Piriformis", "Hips"],
        videoUrl: exerciseVideos["FigureFourStretch"],
        image: null
    },

    "PigeonPose": {
        title: "Pigeon Pose",
        description: "A yoga pose that deeply stretches the hip flexors and glutes.",
        steps: [
            "Start in a plank position.",
            "Bring one knee forward and place it behind your wrist.",
            "Extend the other leg straight back.",
            "Lower down onto your forearms or hands.",
            "Hold the stretch and switch sides."
        ],
        tips: [
            "This is a deep hip opener from yoga.",
            "Don't force the position if you feel knee pain.",
            "Focus on the stretch in your hip and glute.",
            "Use props like blocks if needed for support."
        ],
        muscleGroups: ["Hip Flexors", "Glutes", "Hips"],
        videoUrl: exerciseVideos["PigeonPose"],
        image: null
    },

    "ChildsPose": {
        title: "Child's Pose",
        description: "A restorative yoga pose that stretches the back and provides relaxation.",
        steps: [
            "Kneel on the floor with your big toes touching.",
            "Sit back on your heels.",
            "Fold forward and extend your arms in front of you.",
            "Rest your forehead on the ground.",
            "Breathe deeply and relax."
        ],
        tips: [
            "This is a resting pose in yoga.",
            "Focus on deep breathing and relaxation.",
            "You should feel a gentle stretch in your back.",
            "Great for recovery between intense exercises."
        ],
        muscleGroups: ["Back", "Hips", "Shoulders"],
        videoUrl: exerciseVideos["ChildsPose"],
        image: null
    },

    "StraddleStretch": {
        title: "Straddle Stretch",
        description: "A seated stretch with legs wide apart to improve hip and hamstring flexibility.",
        steps: [
            "Sit with your legs extended wide apart.",
            "Keep your knees and toes pointing toward the ceiling.",
            "Lean forward from your hips.",
            "Reach toward the center or toward each leg.",
            "Hold the stretch and breathe deeply."
        ],
        tips: [
            "Don't round your back - hinge from your hips.",
            "Only go as far as comfortable.",
            "Focus on the stretch in your inner thighs and hamstrings.",
            "Progress gradually - this flexibility takes time to develop."
        ],
        muscleGroups: ["Inner Thighs", "Hamstrings", "Hips"],
        videoUrl: exerciseVideos["StraddleStretch"],
        image: null
    },

    "DownwardFacingDog": {
        title: "Downward Facing Dog",
        description: "A fundamental yoga pose that stretches the entire posterior chain.",
        steps: [
            "Start on your hands and knees.",
            "Tuck your toes under and lift your hips up and back.",
            "Straighten your legs as much as possible.",
            "Create an inverted V-shape with your body.",
            "Hold the position and breathe deeply."
        ],
        tips: [
            "This stretches your calves, hamstrings, and shoulders.",
            "Keep your hands pressed firmly into the ground.",
            "It's okay to bend your knees if your hamstrings are tight.",
            "This is a foundational yoga pose."
        ],
        muscleGroups: ["Hamstrings", "Calves", "Shoulders", "Back"],
        videoUrl: exerciseVideos["DownwardFacingDog"],
        image: null
    },

    "UpwardDog": {
        title: "Upward Dog",
        description: "A yoga pose that opens the chest and strengthens the arms and back.",
        steps: [
            "Lie face down with palms flat beside your chest.",
            "Press up, straightening your arms.",
            "Lift your thighs off the ground.",
            "Open your chest and look slightly upward.",
            "Hold the position while breathing."
        ],
        tips: [
            "This is the opposite stretch of downward dog.",
            "Keep your shoulders over your wrists.",
            "Engage your leg muscles to lift your thighs.",
            "Don't crane your neck too far back."
        ],
        muscleGroups: ["Chest", "Shoulders", "Arms", "Core"],
        videoUrl: exerciseVideos["UpwardDog"],
        image: null
    },

    "CouchStretch": {
        title: "Couch Stretch",
        description: "An intense hip flexor stretch using a couch or elevated surface.",
        steps: [
            "Place your back foot on a couch or bench behind you.",
            "Step your front foot forward into a lunge position.",
            "Lower your back knee toward the ground.",
            "Feel an intense stretch in your back leg's hip flexor.",
            "Hold and switch sides."
        ],
        tips: [
            "This is an intense stretch - go slowly.",
            "Great for people who sit a lot.",
            "You can increase the stretch by moving your front foot further forward.",
            "Made popular by mobility expert Kelly Starrett."
        ],
        muscleGroups: ["Hip Flexors", "Quadriceps"],
        videoUrl: exerciseVideos["CouchStretch"],
        image: null
    },

    "SpidermanStretchWithReach": {
        title: "Spiderman Stretch with Reach",
        description: "A dynamic stretch combining a lunge with thoracic spine rotation.",
        steps: [
            "Step into a deep lunge position.",
            "Place your inside hand on the ground.",
            "Reach your outside arm up and back.",
            "Rotate your spine and open your chest.",
            "Return to center and switch sides."
        ],
        tips: [
            "This combines hip and spine mobility.",
            "Follow your hand with your eyes during the reach.",
            "Great for warming up before workouts.",
            "Focus on the rotation through your spine."
        ],
        muscleGroups: ["Hip Flexors", "Thoracic Spine", "Shoulders"],
        videoUrl: exerciseVideos["SpidermanStretchWithReach"],
        image: null
    },

    "SpidermanAndReach": {
        title: "Spiderman and Reach",
        description: "A mobility exercise combining lunge and rotational movements.",
        steps: [
            "Start in a plank position.",
            "Step one foot up beside your hand.",
            "Reach the same-side arm up toward the ceiling.",
            "Rotate your spine and follow your hand with your eyes.",
            "Return to plank and repeat on the other side."
        ],
        tips: [
            "This is a dynamic warm-up movement.",
            "Keep your planted hand stable.",
            "Focus on the rotation through your thoracic spine.",
            "Great for athletes and general mobility."
        ],
        muscleGroups: ["Hip Flexors", "Thoracic Spine", "Core"],
        videoUrl: exerciseVideos["SpidermanAndReach"],
        image: null
    },

    "DeadMansPos": {
        title: "Dead Man's Pose",
        description: "A restorative yoga pose for complete relaxation and recovery.",
        steps: [
            "Lie flat on your back with legs slightly apart.",
            "Let your arms rest at your sides, palms up.",
            "Close your eyes and relax completely.",
            "Focus on deep, natural breathing.",
            "Let go of all tension in your body."
        ],
        tips: [
            "This is also known as Savasana in yoga.",
            "Focus on progressive muscle relaxation.",
            "This is excellent for stress relief and recovery.",
            "Try to stay awake and mindful during the pose."
        ],
        muscleGroups: ["Full Body Relaxation"],
        videoUrl: exerciseVideos["DeadMansPos"],
        image: null
    },

    "Dorsiflexion": {
        title: "Dorsiflexion",
        description: "An ankle mobility exercise to improve dorsiflexion range of motion.",
        steps: [
            "Stand facing a wall with one foot forward.",
            "Place your hands on the wall for support.",
            "Keep your back heel on the ground.",
            "Lean forward to stretch your calf and ankle.",
            "Hold the stretch and switch sides."
        ],
        tips: [
            "This improves ankle mobility for squats and other movements.",
            "Keep your heel firmly planted on the ground.",
            "You should feel the stretch in your calf and ankle.",
            "Poor ankle mobility can affect many lower body exercises."
        ],
        muscleGroups: ["Calves", "Ankles"],
        videoUrl: exerciseVideos["Dorsiflexion"],
        image: null
    },

    // ===== CARDIO & CONDITIONING =====
    "JumpingJacks": {
        title: "Jumping Jacks",
        description: "A classic cardio exercise involving jumping while moving arms and legs.",
        steps: [
            "Start standing with feet together and arms at your sides.",
            "Jump up while spreading your legs shoulder-width apart.",
            "Simultaneously raise your arms overhead.",
            "Jump back to the starting position.",
            "Repeat at a steady rhythm."
        ],
        tips: [
            "This is a great warm-up and cardio exercise.",
            "Land softly on the balls of your feet.",
            "Keep a steady rhythm throughout.",
            "Modify by stepping side to side instead of jumping if needed."
        ],
        muscleGroups: ["Full Body", "Cardio"],
        videoUrl: exerciseVideos["JumpingJacks"],
        image: null
    },

    "StarJumpingJacks": {
        title: "Star Jumping Jacks",
        description: "A variation of jumping jacks with exaggerated arm and leg movements.",
        steps: [
            "Start in the same position as regular jumping jacks.",
            "Jump up and spread your legs wider than normal.",
            "Extend your arms out wide to form a star shape.",
            "Jump back to the starting position.",
            "Focus on full extension of limbs."
        ],
        tips: [
            "This is a more dynamic version of jumping jacks.",
            "Really focus on the full extension to form a star.",
            "This increases the range of motion and intensity.",
            "Great for improving coordination and cardio fitness."
        ],
        muscleGroups: ["Full Body", "Cardio"],
        videoUrl: exerciseVideos["StarJumpingJacks"],
        image: null
    },

    "HighKnees": {
        title: "High Knees",
        description: "A running-in-place exercise with knees lifted high toward the chest.",
        steps: [
            "Stand in place with good posture.",
            "Run in place while lifting your knees toward your chest.",
            "Aim to bring your knees up to hip level or higher.",
            "Pump your arms naturally as if running.",
            "Maintain a quick, steady pace."
        ],
        tips: [
            "This is excellent for warming up and cardio.",
            "Land on the balls of your feet.",
            "Keep your core engaged throughout.",
            "Focus on quick foot turnover."
        ],
        muscleGroups: ["Hip Flexors", "Calves", "Core", "Cardio"],
        videoUrl: exerciseVideos["HighKnees"],
        image: null
    },

    "JumpRope": {
        title: "Jump Rope",
        description: "A classic cardio exercise using a jump rope for conditioning.",
        steps: [
            "Hold the jump rope handles at your sides.",
            "Swing the rope over your head and under your feet.",
            "Jump just high enough to clear the rope.",
            "Land on the balls of your feet.",
            "Maintain a steady rhythm."
        ],
        tips: [
            "This is one of the best cardio exercises.",
            "Keep your jumps low - only clear the rope.",
            "Relax your shoulders and use your wrists to turn the rope.",
            "Start slowly and build up speed and duration."
        ],
        muscleGroups: ["Calves", "Shoulders", "Forearms", "Cardio"],
        videoUrl: exerciseVideos["JumpRope"],
        image: null
    },

    "LineJumpsFrontAndBack": {
        title: "Line Jumps Front and Back",
        description: "Agility jumps forward and backward over an imaginary line.",
        steps: [
            "Stand with feet together beside an imaginary line.",
            "Jump forward over the line.",
            "Immediately jump back over the line.",
            "Continue jumping back and forth quickly.",
            "Stay light on your feet."
        ],
        tips: [
            "This improves agility and foot speed.",
            "Keep your jumps small and quick.",
            "Stay on the balls of your feet.",
            "Focus on quick ground contact time."
        ],
        muscleGroups: ["Calves", "Agility", "Coordination"],
        videoUrl: exerciseVideos["LineJumpsFrontAndBack"],
        image: null
    },

    "CrabWalk": {
        title: "Crab Walk",
        description: "A quadrupedal movement exercise that builds shoulder and core strength.",
        steps: [
            "Sit on the ground with hands behind you and knees bent.",
            "Lift your hips off the ground.",
            "Walk forward or backward on your hands and feet.",
            "Keep your hips elevated throughout.",
            "Maintain the crab position while moving."
        ],
        tips: [
            "This builds shoulder stability and core strength.",
            "Keep your hips up throughout the movement.",
            "Can walk forward, backward, or sideways.",
            "Start with short distances and build up."
        ],
        muscleGroups: ["Shoulders", "Triceps", "Core", "Glutes"],
        videoUrl: exerciseVideos["CrabWalk"],
        image: null
    },

    "BodyWeightSideToSide": {
        title: "Body Weight Side to Side",
        description: "Lateral movement exercise using bodyweight for agility and conditioning.",
        steps: [
            "Stand in an athletic position with knees slightly bent.",
            "Step or shuffle quickly to one side.",
            "Push off and move quickly to the other side.",
            "Keep your center of gravity low.",
            "Continue moving side to side rhythmically."
        ],
        tips: [
            "This improves lateral agility and conditioning.",
            "Stay low in an athletic position.",
            "Push off powerfully with each direction change.",
            "Keep your movements controlled but quick."
        ],
        muscleGroups: ["Legs", "Glutes", "Core", "Agility"],
        videoUrl: exerciseVideos["BodyWeightSideToSide"],
        image: null
    },

    // ===== BOXING & MARTIAL ARTS =====
    "ShadowBoxing": {
        title: "Shadow Boxing",
        description: "Boxing movements performed without equipment for technique and cardio.",
        steps: [
            "Stand in a boxing stance with hands up.",
            "Throw punches at an imaginary opponent.",
            "Include jabs, crosses, hooks, and uppercuts.",
            "Move your feet and head while punching.",
            "Maintain proper boxing form throughout."
        ],
        tips: [
            "Focus on proper technique over speed initially.",
            "Keep your hands up to protect your face.",
            "Move around and change angles.",
            "This is excellent for cardio and technique practice."
        ],
        muscleGroups: ["Shoulders", "Arms", "Core", "Cardio"],
        videoUrl: exerciseVideos["ShadowBoxing"],
        image: null
    },

    "QuickPunches": {
        title: "Quick Punches",
        description: "Fast, alternating punches for speed and conditioning.",
        steps: [
            "Stand in a boxing stance.",
            "Throw quick, alternating jabs.",
            "Focus on speed over power.",
            "Keep your guard up between punches.",
            "Maintain proper form despite the speed."
        ],
        tips: [
            "This builds hand speed and endurance.",
            "Don't overextend your punches.",
            "Keep your core engaged.",
            "Focus on bringing your hands back quickly."
        ],
        muscleGroups: ["Shoulders", "Arms", "Core"],
        videoUrl: exerciseVideos["QuickPunches"],
        image: null
    },

    "StraightPunches": {
        title: "Straight Punches",
        description: "Linear punching movements focusing on form and power.",
        steps: [
            "Stand in a boxing stance.",
            "Throw straight punches (jabs and crosses).",
            "Rotate your body with each punch.",
            "Keep your other hand up for protection.",
            "Focus on proper technique and power."
        ],
        tips: [
            "This builds punching power and technique.",
            "Rotate your hips and shoulders with each punch.",
            "Keep your punches straight and direct.",
            "Focus on proper form over speed."
        ],
        muscleGroups: ["Shoulders", "Arms", "Core", "Rotation"],
        videoUrl: exerciseVideos["StraightPunches"],
        image: null
    },

    // ===== ADDITIONAL MOVEMENTS =====
    "UnweightedGoodMornings": {
        title: "Unweighted Good Mornings",
        description: "A hip hinge movement performed without weight to teach proper form.",
        steps: [
            "Stand with feet hip-width apart and hands behind your head.",
            "Hinge at the hips and push your butt back.",
            "Lower your torso while keeping your back straight.",
            "Feel a stretch in your hamstrings.",
            "Drive your hips forward to return to standing."
        ],
        tips: [
            "This teaches the hip hinge movement pattern.",
            "Keep your back straight throughout the movement.",
            "Focus on moving at the hips, not the spine.",
            "This is a progression toward weighted good mornings."
        ],
        muscleGroups: ["Hamstrings", "Glutes", "Lower Back"],
        videoUrl: exerciseVideos["UnweightedGoodMornings"],
        image: null
    },

    "AmericanDumbbellSwing": {
        title: "American Dumbbell Swing",
        description: "A dumbbell swing that goes overhead, different from the Russian style.",
        steps: [
            "Hold a dumbbell with both hands.",
            "Stand with feet shoulder-width apart.",
            "Swing the dumbbell between your legs.",
            "Drive your hips forward to swing the dumbbell overhead.",
            "Control the descent and repeat."
        ],
        tips: [
            "This goes higher than Russian swings (overhead vs. chest level).",
            "Generate power from your hips, not your arms.",
            "Keep your core tight throughout.",
            "Be careful not to let the weight pull you forward."
        ],
        muscleGroups: ["Glutes", "Hamstrings", "Shoulders", "Core"],
        videoUrl: exerciseVideos["AmericanDumbbellSwing"],
        image: null
    },

    "HipTouches": {
        title: "Hip Touches",
        description: "A core exercise involving touching your hips while in various positions.",
        steps: [
            "Start in the specified position (standing, plank, etc.).",
            "Reach one hand to touch the opposite hip.",
            "Return to the starting position.",
            "Repeat with the other hand.",
            "Maintain core engagement throughout."
        ],
        tips: [
            "This challenges core stability and coordination.",
            "Keep your hips level during the movement.",
            "Focus on controlled movements.",
            "Don't rush through the exercise."
        ],
        muscleGroups: ["Core", "Obliques", "Stability"],
        videoUrl: exerciseVideos["HipTouches"],
        image: null
    },

    "ToesToBar": {
        title: "Toes to Bar",
        description: "An advanced hanging exercise bringing toes up to touch the pull-up bar.",
        steps: [
            "Hang from a pull-up bar with arms extended.",
            "Engage your core and lift your legs.",
            "Bring your toes up to touch the bar.",
            "Lower your legs back down with control.",
            "Maintain constant tension in your core."
        ],
        tips: [
            "This is an extremely challenging core exercise.",
            "Build up with knee raises and leg raises first.",
            "Use momentum wisely but maintain control.",
            "This requires significant grip strength and core power."
        ],
        muscleGroups: ["Abs", "Hip Flexors", "Forearms", "Lats"],
        videoUrl: exerciseVideos["ToesToBar"],
        image: null
    },

    // ===== ADDITIONAL AB EXERCISES =====
    "LegRaises2": {
        title: "Leg Raises (Variation 2)",
        description: "An alternative leg raise technique with different form emphasis.",
        steps: [
            "Lie on your back with hands at your sides or under your lower back.",
            "Keep your legs straight and together.",
            "Lift your legs slowly toward the ceiling.",
            "Lower them back down without touching the floor.",
            "Focus on controlled movement throughout."
        ],
        tips: [
            "This variation emphasizes strict form and control.",
            "Keep your lower back pressed to the floor.",
            "The slow movement increases time under tension.",
            "Stop just before your legs touch the floor."
        ],
        muscleGroups: ["Lower Abs", "Hip Flexors"],
        videoUrl: exerciseVideos["LegRaises2"],
        image: null
    },

    "SwissBallVups": {
        title: "Swiss Ball V-Ups",
        description: "V-ups performed while holding a Swiss ball for added resistance and coordination.",
        steps: [
            "Lie on your back holding a Swiss ball overhead.",
            "Simultaneously lift your legs and torso.",
            "Pass the ball from your hands to between your legs.",
            "Lower back down while holding the ball with your legs.",
            "Repeat, passing the ball back to your hands."
        ],
        tips: [
            "This adds coordination and resistance to regular V-ups.",
            "Focus on smooth transitions when passing the ball.",
            "Keep your movements controlled throughout.",
            "This is an advanced core exercise."
        ],
        muscleGroups: ["Abs", "Core", "Coordination"],
        videoUrl: exerciseVideos["SwissBallVups"],
        image: null
    },

    "TickTocks": {
        title: "Tick Tocks",
        description: "A core exercise with legs moving side to side like a pendulum.",
        steps: [
            "Lie on your back with legs elevated.",
            "Keep your legs together and straight.",
            "Lower your legs to one side without touching the ground.",
            "Bring them back to center and lower to the other side.",
            "Continue the pendulum motion."
        ],
        tips: [
            "Keep your shoulders pressed to the floor throughout.",
            "Control the movement - don't let gravity take over.",
            "The further you lower your legs, the harder it becomes.",
            "This targets the obliques and deep core muscles."
        ],
        muscleGroups: ["Obliques", "Core", "Hip Flexors"],
        videoUrl: exerciseVideos["TickTocks"],
        image: null
    },

    "ToeTouches": {
        title: "Toe Touches",
        description: "A core exercise reaching toward your toes while lying down.",
        steps: [
            "Lie on your back with legs extended toward the ceiling.",
            "Reach your hands toward your toes.",
            "Crunch up to get your hands as close to your toes as possible.",
            "Lower back down with control.",
            "Keep your legs relatively stationary."
        ],
        tips: [
            "Focus on crunching up rather than just reaching.",
            "Keep your legs as straight as possible.",
            "Don't worry if you can't actually touch your toes.",
            "This targets the upper portion of the rectus abdominis."
        ],
        muscleGroups: ["Upper Abs", "Core"],
        videoUrl: exerciseVideos["ToeTouches"],
        image: null
    },

    "Twisters": {
        title: "Twisters",
        description: "A rotational core exercise with twisting movements.",
        steps: [
            "Sit with your knees bent and feet off the ground.",
            "Lean back slightly while keeping your back straight.",
            "Hold your hands together or hold a weight.",
            "Twist your torso from side to side.",
            "Keep your feet elevated throughout."
        ],
        tips: [
            "This is similar to Russian twists but may have different tempo.",
            "Focus on rotating through your core.",
            "Keep your balance throughout the movement.",
            "Add weight to increase difficulty."
        ],
        muscleGroups: ["Obliques", "Core", "Hip Flexors"],
        videoUrl: exerciseVideos["Twisters"],
        image: null
    },

    "UpperBodyHollowHoldKnee": {
        title: "Upper Body Hollow Hold Knee",
        description: "A hollow hold variation focusing on the upper body with knees bent.",
        steps: [
            "Lie on your back with knees bent toward your chest.",
            "Lift your shoulders off the ground.",
            "Hold your knees while maintaining the hollow position.",
            "Keep your lower back pressed to the floor.",
            "Hold for the desired time."
        ],
        tips: [
            "This is an easier progression toward full hollow holds.",
            "Focus on maintaining the hollow position.",
            "Keep constant tension in your core.",
            "Don't let your lower back arch off the floor."
        ],
        muscleGroups: ["Upper Abs", "Core"],
        videoUrl: exerciseVideos["UpperBodyHollowHoldKnee"],
        image: null
    },

    "UpperLegRaise": {
        title: "Upper Leg Raise",
        description: "A leg raise exercise focusing on the upper portion of the movement.",
        steps: [
            "Lie on your back with legs straight.",
            "Start with your legs already elevated off the ground.",
            "Raise your legs higher toward the ceiling.",
            "Focus on the upper portion of the leg raise movement.",
            "Lower back to the elevated starting position."
        ],
        tips: [
            "This targets the upper range of the leg raise.",
            "Keep your lower back pressed to the floor.",
            "Focus on the peak contraction.",
            "This is more challenging than it appears."
        ],
        muscleGroups: ["Lower Abs", "Hip Flexors"],
        videoUrl: exerciseVideos["UpperLegRaise"],
        image: null
    },


    "TriangleBriefcaseRow": {
        title: "Triangle Briefcase Row",
        description: "A single-arm rowing exercise mimicking lifting a briefcase.",
        steps: [
            "Anchor the triangle band at a low point.",
            "Hold one handle like carrying a briefcase.",
            "Step back to create tension in the band.",
            "Pull the handle up toward your hip.",
            "Control the return to the starting position."
        ],
        tips: [
            "Keep your torso upright throughout the movement.",
            "Focus on pulling with your back muscles.",
            "Don't let your shoulder roll forward.",
            "Work both sides equally."
        ],
        muscleGroups: ["Lats", "Rhomboids", "Biceps", "Core"],
        videoUrl: exerciseVideos["TriangleBriefcaseRow"],
        image: null
    },

    "TriangleDoubleBriefcase": {
        title: "Triangle Double Briefcase",
        description: "A dual-arm rowing exercise using both handles like carrying two briefcases.",
        steps: [
            "Anchor the triangle band at a low point.",
            "Hold both handles at your sides.",
            "Step back to create tension.",
            "Pull both handles up simultaneously.",
            "Control the return to the starting position."
        ],
        tips: [
            "Keep your movements synchronized.",
            "Maintain good posture throughout.",
            "Focus on squeezing your shoulder blades together.",
            "Don't let the band snap back quickly."
        ],
        muscleGroups: ["Lats", "Rhomboids", "Middle Traps", "Biceps"],
        videoUrl: exerciseVideos["TriangleDoubleBriefcase"],
        image: null
    },

    "TriangleBoxing": {
        title: "Triangle Boxing",
        description: "Boxing movements using triangle bands for resistance training.",
        steps: [
            "Anchor the band behind you at chest height.",
            "Hold the triangle handles in a boxing stance.",
            "Throw punches while fighting against the band resistance.",
            "Alternate between jabs, crosses, and hooks.",
            "Keep your feet planted and core engaged."
        ],
        tips: [
            "Focus on proper boxing form despite the resistance.",
            "Keep your guard up between punches.",
            "Don't overextend your punches.",
            "This improves punching power and endurance."
        ],
        muscleGroups: ["Shoulders", "Chest", "Core", "Arms"],
        videoUrl: exerciseVideos["TriangleBoxing"],
        image: null
    },

// ===== G87 BAND EXERCISES =====
    "G87OneArmFrontRaise": {
        title: "G87 One Arm Front Raise",
        description: "Single-arm front raises using G87 resistance bands.",
        steps: [
            "Stand on the band with one foot.",
            "Hold one handle with your working arm at your side.",
            "Raise your arm straight out in front to shoulder height.",
            "Lower back down with control.",
            "Complete all reps before switching arms."
        ],
        tips: [
            "Keep your arm straight throughout the movement.",
            "Don't swing or use momentum.",
            "Focus on the front deltoid muscle.",
            "Keep your core engaged for stability."
        ],
        muscleGroups: ["Front Delts", "Core"],
        videoUrl: exerciseVideos["G87OneArmFrontRaise"],
        image: null
    },

// ===== PUSH-UP VARIATIONS =====
    "SlowPushUps": {
        title: "Slow Push Ups",
        description: "Push-ups performed with deliberately slow tempo for increased time under tension.",
        steps: [
            "Start in a standard push-up position.",
            "Lower yourself down slowly, taking 3-4 seconds.",
            "Pause briefly at the bottom.",
            "Push back up slowly, taking 3-4 seconds.",
            "Focus on control throughout the entire range."
        ],
        tips: [
            "The slow tempo increases muscle activation.",
            "Fight the urge to speed up when fatigued.",
            "This builds strength in all ranges of motion.",
            "Quality is more important than quantity."
        ],
        muscleGroups: ["Chest", "Shoulders", "Triceps", "Core"],
        videoUrl: exerciseVideos["SlowPushUps"],
        image: null
    },

    "TPushUps": {
        title: "T Push Ups",
        description: "Push-ups with a side plank rotation, forming a 'T' shape.",
        steps: [
            "Start in a standard push-up position.",
            "Perform a push-up.",
            "At the top, rotate to one side, extending one arm to the ceiling.",
            "Form a 'T' shape with your body.",
            "Return to push-up position and repeat on the other side."
        ],
        tips: [
            "Keep your core tight during the rotation.",
            "Stack your feet during the side plank portion.",
            "This combines push-up strength with core stability.",
            "Start with the rotation only if full exercise is too difficult."
        ],
        muscleGroups: ["Chest", "Shoulders", "Triceps", "Core", "Obliques"],
        videoUrl: exerciseVideos["TPushUps"],
        image: null
    },

    "StaggeredArmPushUps": {
        title: "Staggered Arm Push Ups",
        description: "Push-ups with one hand forward and one hand back for uneven challenge.",
        steps: [
            "Start in push-up position with one hand forward, one back.",
            "Perform push-ups in this staggered position.",
            "Keep your core engaged to prevent rotation.",
            "Complete desired reps, then switch hand positions.",
            "Focus on maintaining stability."
        ],
        tips: [
            "This creates uneven loading and challenges stability.",
            "Keep your body as straight as possible.",
            "The exercise becomes harder the more staggered your hands are.",
            "Work both sides equally."
        ],
        muscleGroups: ["Chest", "Shoulders", "Triceps", "Core"],
        videoUrl: exerciseVideos["StaggeredArmPushUps"],
        image: null
    },

    "InchwormPushUps": {
        title: "Inchworm Push Ups",
        description: "A combination exercise moving from standing to push-up position like an inchworm.",
        steps: [
            "Start standing with feet together.",
            "Bend over and place your hands on the ground.",
            "Walk your hands forward into a push-up position.",
            "Perform a push-up.",
            "Walk your hands back toward your feet and stand up."
        ],
        tips: [
            "Keep your legs as straight as possible when walking hands out.",
            "This combines flexibility, core strength, and upper body strength.",
            "Move slowly and with control.",
            "Great for warming up or as a standalone exercise."
        ],
        muscleGroups: ["Chest", "Shoulders", "Core", "Hamstrings", "Full Body"],
        videoUrl: exerciseVideos["InchwormPushUps"],
        image: null
    },

    "KneePushUpsWithRow": {
        title: "Knee Push Ups with Row",
        description: "Modified push-ups from knees with added rowing motion.",
        steps: [
            "Start in a knee push-up position.",
            "Perform a push-up from your knees.",
            "At the top, perform a rowing motion with one or both arms.",
            "Return to the starting position.",
            "Alternate arms or use both arms for the rowing motion."
        ],
        tips: [
            "The knee position makes this accessible for beginners.",
            "Focus on squeezing your shoulder blades during the row.",
            "Keep your core engaged throughout.",
            "This combines pushing and pulling movements."
        ],
        muscleGroups: ["Chest", "Shoulders", "Triceps", "Back", "Core"],
        videoUrl: exerciseVideos["KneePushUpsWithRow"],
        image: null
    },

    "PendulumPushUps": {
        title: "Pendulum Push Ups",
        description: "Push-ups with side-to-side movement like a pendulum.",
        steps: [
            "Start in a push-up position.",
            "Lower down while shifting your weight to one side.",
            "Push up while moving to the center.",
            "Lower down while shifting to the other side.",
            "Continue the pendulum motion."
        ],
        tips: [
            "This adds lateral movement to traditional push-ups.",
            "Keep your core engaged to control the movement.",
            "Start with small movements and progress to larger shifts.",
            "This challenges stability in multiple planes."
        ],
        muscleGroups: ["Chest", "Shoulders", "Triceps", "Core"],
        videoUrl: exerciseVideos["PendulumPushUps"],
        image: null
    },

    "ReversePushUps": {
        title: "Reverse Push Ups",
        description: "Push-ups performed facing upward, targeting the triceps heavily.",
        steps: [
            "Sit with your back to a bench or elevated surface.",
            "Place your hands on the edge behind you.",
            "Extend your legs out in front.",
            "Lower your body by bending your elbows.",
            "Push back up to the starting position."
        ],
        tips: [
            "This is similar to tricep dips.",
            "Keep your body close to the bench.",
            "Focus on using your triceps to push up.",
            "Bend your knees to make it easier."
        ],
        muscleGroups: ["Triceps", "Shoulders", "Chest"],
        videoUrl: exerciseVideos["ReversePushUps"],
        image: null
    },

    "PancakePushUps": {
        title: "Pancake Push Ups",
        description: "Wide-grip push-ups with a focus on 'pancaking' to the ground.",
        steps: [
            "Start in a push-up position with hands wider than normal.",
            "Lower your entire torso toward the ground like a pancake.",
            "Keep your body flat as you descend.",
            "Push back up maintaining the flat position.",
            "Focus on even descent of your entire body."
        ],
        tips: [
            "This emphasizes keeping your body rigid.",
            "The wide grip targets more chest muscles.",
            "Don't let your hips sag or pike up.",
            "This variation challenges core stability."
        ],
        muscleGroups: ["Chest", "Shoulders", "Triceps", "Core"],
        videoUrl: exerciseVideos["PancakePushUps"],
        image: null
    },

    "WideKneePushUps": {
        title: "Wide Knee Push Ups",
        description: "Knee push-ups performed with a wider hand position.",
        steps: [
            "Start in a knee push-up position with hands wider than normal.",
            "Lower your chest toward the ground.",
            "Keep your knees on the ground for support.",
            "Push back up to the starting position.",
            "Focus on the wide grip chest activation."
        ],
        tips: [
            "This makes wide-grip push-ups accessible for beginners.",
            "Don't go too wide as it can stress the shoulders.",
            "Focus on feeling the stretch in your chest.",
            "Progress toward full wide-grip push-ups."
        ],
        muscleGroups: ["Chest", "Shoulders", "Triceps"],
        videoUrl: exerciseVideos["WideKneePushUps"],
        image: null
    },

    "SwissBallPushUps": {
        title: "Swiss Ball Push Ups",
        description: "Push-ups performed with hands or feet on a stability ball.",
        steps: [
            "Place your hands on a Swiss ball and assume push-up position.",
            "Keep your core extra tight for stability.",
            "Lower your chest toward the ball.",
            "Push back up while maintaining balance.",
            "Focus on stability throughout the movement."
        ],
        tips: [
            "This significantly increases the stability challenge.",
            "Start with hands on ball, progress to feet on ball.",
            "Keep your core engaged throughout.",
            "This improves proprioception and core strength."
        ],
        muscleGroups: ["Chest", "Shoulders", "Triceps", "Core", "Stabilizers"],
        videoUrl: exerciseVideos["SwissBallPushUps"],
        image: null
    },

    "RockingHorsePushUps": {
        title: "Rocking Horse Push Ups",
        description: "Push-ups with a rocking motion forward and backward.",
        steps: [
            "Start in a push-up position.",
            "Rock your body forward over your hands.",
            "Lower down in the forward position.",
            "Push up while rocking back to center.",
            "Continue the rocking motion with each rep."
        ],
        tips: [
            "This adds a dynamic element to push-ups.",
            "The rocking motion challenges different muscle angles.",
            "Keep your core tight throughout the movement.",
            "Start with small rocking motions."
        ],
        muscleGroups: ["Chest", "Shoulders", "Triceps", "Core"],
        videoUrl: exerciseVideos["RockingHorsePushUps"],
        image: null
    },

    "SpidermanWalkingPushUps": {
        title: "Spiderman Walking Push Ups",
        description: "Push-ups combined with forward movement and spiderman leg actions.",
        steps: [
            "Start in a push-up position.",
            "Step one hand forward while bringing the same-side knee to elbow.",
            "Perform a push-up in this position.",
            "Step the other hand forward with the opposite knee to elbow.",
            "Continue 'walking' forward while doing spiderman push-ups."
        ],
        tips: [
            "This combines locomotion with upper body strength.",
            "Keep your hips level throughout the movement.",
            "Coordinate the hand and leg movements smoothly.",
            "This is an advanced, full-body exercise."
        ],
        muscleGroups: ["Chest", "Shoulders", "Triceps", "Core", "Hip Flexors"],
        videoUrl: exerciseVideos["SpidermanWalkingPushUps"],
        image: null
    },

    "UnderTheFencePushUpsFromKnees": {
        title: "Under the Fence Push Ups from Knees",
        description: "Low push-ups from knees simulating crawling under a fence.",
        steps: [
            "Start in a knee push-up position.",
            "Lower your body very close to the ground.",
            "Crawl forward slightly while staying low.",
            "Push back up and return to starting position.",
            "Imagine crawling under a very low fence."
        ],
        tips: [
            "This emphasizes staying very low to the ground.",
            "Keep your body as flat as possible.",
            "The knee position makes this accessible.",
            "Focus on core engagement to stay low."
        ],
        muscleGroups: ["Chest", "Shoulders", "Triceps", "Core"],
        videoUrl: exerciseVideos["UnderTheFencePushUpsFromKnees"],
        image: null
    },

    "HandReleasePushUpsKnee": {
        title: "Hand Release Push Ups from Knees",
        description: "Knee push-ups with hand release at the bottom to eliminate momentum.",
        steps: [
            "Start in a knee push-up position.",
            "Lower your chest all the way to the ground.",
            "Lift your hands off the ground briefly.",
            "Place your hands back down and push up.",
            "Focus on starting each rep from a dead stop."
        ],
        tips: [
            "This eliminates the stretch reflex making each rep harder.",
            "The knee position makes it accessible for beginners.",
            "Focus on pressing the ground away from you.",
            "Each rep starts from zero momentum."
        ],
        muscleGroups: ["Chest", "Shoulders", "Triceps", "Core"],
        videoUrl: exerciseVideos["HandReleasePushUpsKnee"],
        image: null
    },

    "DumbbellPushUpRow": {
        title: "Dumbbell Push Up Row",
        description: "Push-ups performed on dumbbells with rowing motions added.",
        steps: [
            "Hold dumbbells and assume push-up position.",
            "Perform a push-up while gripping the dumbbells.",
            "At the top, row one dumbbell up to your ribs.",
            "Lower the dumbbell and row with the other arm.",
            "Continue alternating rows between push-ups."
        ],
        tips: [
            "This combines pushing and pulling movements.",
            "Keep your core tight to prevent rotation during rows.",
            "Use hexagonal dumbbells for better stability.",
            "Start with lighter weights to master the coordination."
        ],
        muscleGroups: ["Chest", "Back", "Shoulders", "Triceps", "Core"],
        videoUrl: exerciseVideos["DumbbellPushUpRow"],
        image: null
    },

    "SingleArmMedicineBallPushUps": {
        title: "Single Arm Medicine Ball Push Ups",
        description: "Push-ups with one hand on a medicine ball for unilateral challenge.",
        steps: [
            "Place one hand on a medicine ball, other on the ground.",
            "Assume push-up position with hands at different heights.",
            "Perform push-ups in this uneven position.",
            "Switch the medicine ball to the other hand.",
            "Focus on maintaining stability."
        ],
        tips: [
            "This creates uneven loading and challenges stability.",
            "The medicine ball adds instability.",
            "Keep your core extra tight.",
            "Work both sides equally."
        ],
        muscleGroups: ["Chest", "Shoulders", "Triceps", "Core", "Stabilizers"],
        videoUrl: exerciseVideos["SingleArmMedicineBallPushUps"],
        image: null
    },

// ===== BACK EXERCISES =====
    "ChinUpsOneArmRight": {
        title: "One Arm Chin Ups (Right)",
        description: "An advanced unilateral pulling exercise using only the right arm.",
        steps: [
            "Hang from a pull-up bar using only your right hand.",
            "Keep your left arm at your side or across your body.",
            "Pull yourself up until your chin clears the bar.",
            "Lower yourself down with control.",
            "This is an extremely advanced exercise."
        ],
        tips: [
            "This requires exceptional upper body strength.",
            "Work up to this with assisted one-arm variations first.",
            "Use proper progressions including negative reps.",
            "Consider using a towel or rope for the non-working hand initially."
        ],
        muscleGroups: ["Biceps", "Lats", "Rhomboids", "Forearms"],
        videoUrl: exerciseVideos["ChinUpsOneArmRight"],
        image: null
    },

    "PullUp": {
        title: "Pull Up (Single)",
        description: "A single repetition pull-up focusing on perfect form.",
        steps: [
            "Hang from a pull-up bar with an overhand grip.",
            "Start with arms fully extended.",
            "Pull yourself up until your chin clears the bar.",
            "Hold briefly at the top.",
            "Lower yourself back down with control."
        ],
        tips: [
            "Quality over quantity - focus on perfect form.",
            "Full range of motion is crucial.",
            "Don't swing or use momentum.",
            "This is the foundation for all pull-up variations."
        ],
        muscleGroups: ["Lats", "Rhomboids", "Middle Traps", "Biceps"],
        videoUrl: exerciseVideos["PullUp"],
        image: null
    },

    "BentOverRows": {
        title: "Bent Over Rows",
        description: "A fundamental rowing exercise performed in a bent-over position.",
        steps: [
            "Hold a barbell or dumbbells with feet hip-width apart.",
            "Hinge at the hips and lean forward with a straight back.",
            "Let the weights hang at arm's length.",
            "Pull the weights up to your lower ribs.",
            "Lower back down with control."
        ],
        tips: [
            "Keep your back straight and core engaged.",
            "Pull with your back muscles, not just your arms.",
            "Squeeze your shoulder blades together at the top.",
            "Don't let the weights swing or use momentum."
        ],
        muscleGroups: ["Lats", "Rhomboids", "Middle Traps", "Biceps"],
        videoUrl: exerciseVideos["BentOverRows"],
        image: null
    },

    "TBarRows": {
        title: "T-Bar Rows",
        description: "A rowing exercise using a T-bar apparatus for back development.",
        steps: [
            "Straddle the T-bar with feet shoulder-width apart.",
            "Bend at the hips and grab the handles.",
            "Keep your back straight and chest up.",
            "Pull the weight up to your chest.",
            "Lower back down with control."
        ],
        tips: [
            "Keep your back in a neutral position throughout.",
            "Pull with your back muscles, not your arms.",
            "Squeeze your shoulder blades together at the top.",
            "This variation allows for heavier loads than other rows."
        ],
        muscleGroups: ["Lats", "Rhomboids", "Middle Traps", "Biceps"],
        videoUrl: exerciseVideos["TBarRows"],
        image: null
    },

    "SeatedCableRows": {
        title: "Seated Cable Rows",
        description: "A rowing exercise performed seated using a cable machine.",
        steps: [
            "Sit at a cable row station with feet on the platform.",
            "Grab the handle with both hands.",
            "Keep your back straight and chest up.",
            "Pull the handle to your lower ribs.",
            "Slowly return to the starting position."
        ],
        tips: [
            "Don't round your back during the movement.",
            "Focus on squeezing your shoulder blades together.",
            "Keep your torso relatively stationary.",
            "Control both the pulling and releasing phases."
        ],
        muscleGroups: ["Lats", "Rhomboids", "Middle Traps", "Biceps"],
        videoUrl: exerciseVideos["SeatedCableRows"],
        image: null
    },

    "SeatedCableRow": {
        title: "Seated Cable Row (Single)",
        description: "A single repetition seated cable row focusing on perfect form.",
        steps: [
            "Sit at a cable row station with feet on the platform.",
            "Grab the handle with both hands.",
            "Keep your back straight and chest up.",
            "Pull the handle to your lower ribs with control.",
            "Slowly return to the starting position."
        ],
        tips: [
            "Focus on perfect form for this single rep.",
            "Feel the full range of motion.",
            "Squeeze your shoulder blades together at the peak.",
            "This is the foundation movement for all cable row variations."
        ],
        muscleGroups: ["Lats", "Rhomboids", "Middle Traps", "Biceps"],
        videoUrl: exerciseVideos["SeatedCableRow"],
        image: null
    },

    "LatPulldowns": {
        title: "Lat Pulldowns",
        description: "A pulling exercise using a lat pulldown machine to target the latissimus dorsi.",
        steps: [
            "Sit at a lat pulldown machine with thighs secured under pads.",
            "Grab the bar with a wide overhand grip.",
            "Pull the bar down to your upper chest.",
            "Squeeze your shoulder blades together.",
            "Slowly return the bar to the starting position."
        ],
        tips: [
            "Don't pull the bar behind your neck.",
            "Focus on pulling with your back muscles, not your arms.",
            "Keep your torso upright throughout the movement.",
            "This is an excellent progression toward pull-ups."
        ],
        muscleGroups: ["Lats", "Rhomboids", "Middle Traps", "Biceps"],
        videoUrl: exerciseVideos["LatPulldowns"],
        image: null
    },

    "Hyperextensions": {
        title: "Hyperextensions",
        description: "A back extension exercise performed on a hyperextension bench.",
        steps: [
            "Position yourself on a hyperextension bench.",
            "Cross your arms over your chest or place hands behind head.",
            "Lower your torso until you feel a stretch in your hamstrings.",
            "Raise your torso back up to neutral position.",
            "Don't hyperextend beyond neutral spine."
        ],
        tips: [
            "Don't go too high - stop at neutral spine position.",
            "Focus on using your glutes and hamstrings.",
            "Keep the movement controlled.",
            "This strengthens the entire posterior chain."
        ],
        muscleGroups: ["Lower Back", "Glutes", "Hamstrings"],
        videoUrl: exerciseVideos["Hyperextensions"],
        image: null
    },

    "Hyperextension": {
        title: "Hyperextension (Single)",
        description: "A single repetition hyperextension focusing on perfect form.",
        steps: [
            "Position yourself on a hyperextension bench.",
            "Cross your arms over your chest.",
            "Lower your torso with control.",
            "Feel the stretch in your posterior chain.",
            "Raise back up to neutral position slowly."
        ],
        tips: [
            "Quality over quantity - focus on perfect form.",
            "Don't hyperextend beyond neutral spine.",
            "Feel the muscles working throughout the range.",
            "This builds the foundation for all back extension movements."
        ],
        muscleGroups: ["Lower Back", "Glutes", "Hamstrings"],
        videoUrl: exerciseVideos["Hyperextension"],
        image: null
    },

// ===== ARM EXERCISES =====
    "HammerCurls": {
        title: "Hammer Curls",
        description: "A bicep exercise using a neutral grip to target the brachialis muscle.",
        steps: [
            "Hold dumbbells at your sides with a neutral grip (palms facing each other).",
            "Keep your elbows close to your sides.",
            "Curl the weights up toward your shoulders.",
            "Squeeze at the top and lower with control.",
            "Keep your wrists straight throughout."
        ],
        tips: [
            "The neutral grip targets different muscles than regular curls.",
            "Don't swing or use momentum.",
            "Focus on the biceps and brachialis muscles.",
            "This variation is often easier on the wrists."
        ],
        muscleGroups: ["Biceps", "Brachialis", "Forearms"],
        videoUrl: exerciseVideos["HammerCurls"],
        image: null
    },

    "PreacherCurls": {
        title: "Preacher Curls",
        description: "Bicep curls performed on a preacher bench for isolation.",
        steps: [
            "Sit at a preacher bench with your chest against the pad.",
            "Hold a barbell or dumbbells with an underhand grip.",
            "Rest your arms on the angled pad.",
            "Curl the weight up while keeping your arms on the pad.",
            "Lower back down with control."
        ],
        tips: [
            "The preacher bench prevents cheating and isolates the biceps.",
            "Don't fully extend your arms at the bottom to protect your elbows.",
            "Focus on the peak contraction at the top.",
            "Control the negative portion of the movement."
        ],
        muscleGroups: ["Biceps"],
        videoUrl: exerciseVideos["PreacherCurls"],
        image: null
    },

    "TricepExtensions": {
        title: "Tricep Extensions",
        description: "An isolation exercise targeting the triceps with overhead extension.",
        steps: [
            "Hold a dumbbell or barbell overhead with both hands.",
            "Keep your elbows close to your head.",
            "Lower the weight behind your head by bending your elbows.",
            "Extend your arms back up to the starting position.",
            "Keep your upper arms stationary throughout."
        ],
        tips: [
            "Don't let your elbows flare out to the sides.",
            "Keep your core engaged for stability.",
            "Focus on isolating the tricep muscles.",
            "Can be performed seated or standing."
        ],
        muscleGroups: ["Triceps"],
        videoUrl: exerciseVideos["TricepExtensions"],
        image: null
    },

    "SkullCrushers": {
        title: "Skull Crushers",
        description: "A tricep exercise performed lying down with weights lowered toward the forehead.",
        steps: [
            "Lie on a bench holding a barbell or dumbbells above your chest.",
            "Keep your elbows stationary and pointing toward the ceiling.",
            "Lower the weight toward your forehead by bending your elbows.",
            "Extend your arms back up to the starting position.",
            "Keep your upper arms perpendicular to the floor."
        ],
        tips: [
            "Don't let your elbows drift forward during the movement.",
            "Lower the weight slowly and with control.",
            "Focus on feeling the stretch and contraction in your triceps.",
            "Use a spotter for safety with heavier weights."
        ],
        muscleGroups: ["Triceps"],
        videoUrl: exerciseVideos["SkullCrushers"],
        image: null
    },

    "TriangleBentRow": {
        title: "Triangle Bent Row",
        description: "A rowing exercise using triangle bands for back muscle development.",
        steps: [
            "Stand on the triangle band with feet hip-width apart.",
            "Hold the handles with an overhand grip.",
            "Hinge at the hips and lean forward slightly.",
            "Pull the handles toward your lower ribs.",
            "Slowly lower back to the starting position."
        ],
        tips: [
            "Keep your back straight and chest up.",
            "Squeeze your shoulder blades together at the top.",
            "Don't use momentum to pull the band.",
            "Keep your elbows close to your body."
        ],
        muscleGroups: ["Lats", "Rhomboids", "Middle Traps", "Biceps"],
        videoUrl: exerciseVideos["TriangleBentRow"],
        image: null
    },

    "LegPress": {
        title: "Leg Press",
        description: "A seated leg exercise using a leg press machine for quadriceps development.",
        steps: [
            "Sit in the leg press machine with your back against the pad.",
            "Place your feet on the footplate shoulder-width apart.",
            "Lower the weight by bending your knees toward your chest.",
            "Press the weight back up through your heels.",
            "Don't lock your knees completely at the top."
        ],
        tips: [
            "Keep your knees tracking over your toes.",
            "Don't lower the weight too far if you feel lower back discomfort.",
            "This allows for heavier loads than squats.",
            "Focus on full range of motion within comfortable limits."
        ],
        muscleGroups: ["Quadriceps", "Glutes", "Hamstrings"],
        videoUrl: exerciseVideos["LegPress"],
        image: null
    },

    "G87WideGripOneArmFrontRaise": {
        title: "G87 Wide Grip One Arm Front Raise",
        description: "A single-arm front raise using a wide grip position with G87 resistance bands.",
        steps: [
            "Stand on the band with feet hip-width apart.",
            "Hold one handle with a wide grip position.",
            "Keep your working arm straight.",
            "Raise your arm straight out in front to shoulder height.",
            "Lower back down with control."
        ],
        tips: [
            "The wide grip changes the angle of resistance.",
            "Keep your core engaged for stability.",
            "Don't swing or use momentum.",
            "Focus on the front deltoid muscle."
        ],
        muscleGroups: ["Front Delts", "Core"],
        videoUrl: exerciseVideos["G87WideGripOneArmFrontRaise"],
        image: null
    },

    "TriangleOneArmFrontRaise": {
        title: "Triangle One Arm Front Raise",
        description: "A unilateral front raise exercise using triangle bands for shoulder development.",
        steps: [
            "Stand on the triangle band with one foot.",
            "Hold one handle with your working arm at your side.",
            "Raise your arm straight out in front to shoulder height.",
            "Keep your arm straight throughout the movement.",
            "Lower back down with control."
        ],
        tips: [
            "Keep your torso stable and avoid leaning.",
            "Focus on the front deltoid muscle.",
            "Don't let your shoulder roll forward.",
            "Work both arms equally."
        ],
        muscleGroups: ["Front Delts", "Core"],
        videoUrl: exerciseVideos["TriangleOneArmFrontRaise"],
        image: null
    },

    "TriangleOneArmSwing": {
        title: "Triangle One Arm Swing",
        description: "A dynamic swinging movement using triangle bands for power and coordination.",
        steps: [
            "Hold one triangle handle with your working arm.",
            "Start with the band anchored at a low point.",
            "Swing your arm up and across your body.",
            "Control the return swing back to the starting position.",
            "Maintain core engagement throughout."
        ],
        tips: [
            "This is a dynamic, athletic movement.",
            "Focus on generating power from your core.",
            "Keep the movement controlled despite the swing.",
            "Work both arms equally."
        ],
        muscleGroups: ["Shoulders", "Core", "Arms"],
        videoUrl: exerciseVideos["TriangleOneArmSwing"],
        image: null
    },

    "TriangleFrontRaise": {
        title: "Triangle Front Raise",
        description: "A bilateral front raise exercise using triangle bands for shoulder strength.",
        steps: [
            "Stand on the triangle band with feet shoulder-width apart.",
            "Hold both handles at your sides with arms straight.",
            "Raise both arms straight out in front to shoulder height.",
            "Keep your arms parallel to each other.",
            "Lower back down with control."
        ],
        tips: [
            "Keep your core engaged throughout the movement.",
            "Don't swing or use momentum.",
            "Stop at shoulder height - don't go higher.",
            "Focus on the front deltoid muscles."
        ],
        muscleGroups: ["Front Delts", "Core"],
        videoUrl: exerciseVideos["TriangleFrontRaise"],
        image: null
    },

    "G87WideGripDoorSmash": {
        title: "G87 Wide Grip Door Smash",
        description: "A wide grip variation of the door smash exercise for enhanced chest and shoulder engagement.",
        steps: [
            "Anchor the band to a door at chest height.",
            "Face away from the door holding the handles with a wide grip.",
            "Step forward to create tension in the band.",
            "Bring your hands together in front of your chest with a wide arc.",
            "Slowly return to the starting position."
        ],
        tips: [
            "The wide grip targets more of the outer chest.",
            "Keep your feet staggered for better stability.",
            "Maintain a slight forward lean.",
            "Control the movement on the way back."
        ],
        muscleGroups: ["Chest", "Shoulders", "Core"],
        videoUrl: exerciseVideos["G87WideGripDoorSmash"],
        image: null
    },

    "PlankVariations": {
        title: "Plank Variations",
        description: "A collection of plank exercise modifications to challenge core stability in different ways.",
        steps: [
            "Start in a standard plank position.",
            "Maintain proper plank form throughout all variations.",
            "Progress through different variations: standard, side, reverse, single-arm, single-leg.",
            "Hold each variation for desired time.",
            "Focus on maintaining perfect form over duration."
        ],
        tips: [
            "Master the basic plank before progressing to variations.",
            "Keep your body in a straight line throughout.",
            "Breathe normally during all holds.",
            "Progress gradually to more challenging variations."
        ],
        muscleGroups: ["Core", "Shoulders", "Glutes"],
        videoUrl: exerciseVideos["PlankVariations"],
        image: null
    },


    "BicepCurls2": {
        title: "Bicep Curls (Variation 2)",
        description: "An alternative bicep curl technique with different form focus.",
        steps: [
            "Hold dumbbells or a barbell with arms at your sides.",
            "Keep your elbows locked in position at your sides.",
            "Curl the weight up with a strong contraction.",
            "Hold the peak contraction briefly.",
            "Lower the weight slowly, fighting gravity."
        ],
        tips: [
            "This variation emphasizes strict form and control.",
            "Focus on the mind-muscle connection.",
            "Don't let your elbows drift forward.",
            "The slow negative builds strength."
        ],
        muscleGroups: ["Biceps", "Forearms"],
        videoUrl: exerciseVideos["BicepCurls2"],
        image: null
    },
}

